<!-- Page Wrapper -->
<app-sticky-icons></app-sticky-icons>

<div
  [ngClass]="{
    'page-wrapper2': router.url === '/dashboard',
    'page-wrapper': router.url !== '/dashboard'
  }"
  style="min-height: 347px"
>
  <div class="content container-fluid">
    <div class="bg-white page-border">
      <!--page header contant-->
      <div *ngIf="marqueeText" class="row row-replace">
        <div class="col-12">
          <p class="text-danger">
            <marquee>{{ marqueeText }}</marquee>
          </p>
        </div>
      </div>
      <!------------------------------------------------------------------------------------------------------->
      <div class="col-md-12 container-fluid">
        <div class="row">
          <div class="col-md-3" style="z-index: 999">
            <div
              class="justify-content-center align-items-center cus-margin"
              *ngIf="empData"
            >
              <div class="card text-center card-home">
                <div class="upper"></div>
                <div class="user bg-white" style="height: 70px !important">
                  <div class="w-100 profile">
                    <img
                      [src]="empData.emp_img"
                      class="rounded-circle"
                      width="100"
                    />
                    <p class="mb-0">
                      {{ empData.emp_name }}
                      <span class="font-weight-normal"
                        >({{ empData.username }})</span
                      >
                    </p>
                    <span class="font-weight-normal">{{
                      empData.cc_desc
                    }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-3 card-home">
              <div class="card-header1 heading1 border-up bg-main">
                Policy Repository
                <span (click)="showPolicy()">view all</span>
              </div>
              <ul class="card-list p-0">
                <li *ngFor="let pol of policies">
                  <img class="icon-main" src="assets/new_icon/policy.svg" />
                  <span class="policy-repo">
                    <a
                      [href]="pol.attachment"
                      target="_blank"
                      class="position-relative d-inline"
                    >
                      {{
                        pol.label.length > 30
                          ? (pol.label | slice : 0 : 30) + ".."
                          : pol.label
                      }}
                      <!-- <span class="position-absolute text-light badgesetting badge rounded-pill bg-danger">
                  NEW
                </span> -->
                    </a>
                  </span>
                </li>
              </ul>
            </div>

            <!-- <div class="mt-3 card-home" (click)="stpHngr()" style="cursor: pointer;">
              <div class="card-header1 heading1 border-up bg-main">
                Stop Hunger
                <span><i class="fa fa-arrow-right"></i></span>
              </div>
              <div class="row p-3">
                <div class="col-md-4">
                  <img src="assets/img/stop-hun.jpg" width="75" alt="">
                </div>
                <div class="col-md-8 my-auto">
                  <span class="font-weight-bold h5">Donate Now</span><br>
                  <span class="text-danger">Let's Stop This Hunger Today</span>
                </div>
              </div>
            </div> -->

            <div class="mt-3 card-home">
              <div class="card-header1 heading1 border-up bg-main">
                New Joinings
                <!-- <span>view all</span> -->
              </div>
              <div
                class="card-header1 text-center bg-white border-down border-0 mb-3 pt-1 approval-card"
              >
                <div *ngIf="countNewJoining != 0; else nojoin">
                  <div
                    class="shadow-main border-down border-up mt-3"
                    *ngFor="let newJoin of newJoiningList"
                  >
                    <div
                      [ngClass]="
                        newJoin.gender_name == 'Female'
                          ? 'card-top-border-pink'
                          : 'card-top-border-blue'
                      "
                    ></div>
                    <div
                      class="card-body position-relative border-down pt-0 pb-1"
                      [ngClass]="
                        newJoin.gender_name == 'Female'
                          ? 'bg-light-pink'
                          : 'bg-light-blue'
                      "
                    >
                      <p class="pt-03 mb-1 fs-12 fw-500">{{ newJoin.doj }}</p>
                      <h6 class="font-weight-bold mb-1">Welcome on board!</h6>
                      <img
                        [src]="newJoin.emp_img"
                        width="36"
                        onError="src = 'assets/img/profile.webp'"
                      />
                      <p class="fs-11 fw-600 mb-0">{{ newJoin.EmpName }}</p>
                      <p class="fs-11 fw-500 mb-0">{{ newJoin.cc_desc }}</p>
                      <p class="fs-11 fw-500 mb-1">{{ newJoin.desig_desc }}</p>
                      <button
                        type="button"
                        class="bg-main2 effect_btn btn-abso2"
                        (click)="sendOnboardWish(newJoin)"
                      >
                        Send Wish
                      </button>
                    </div>
                  </div>
                </div>
                <ng-template #nojoin>
                  <div class="no-data-card">
                    <h5 class="text-center">
                      {{ "No New Joinings." | translate }}
                    </h5>
                  </div>
                </ng-template>
              </div>
            </div>

            <div class="mt-3 card-home">
              <div class="card-header1 heading1 border-up bg-main">
                Birthdays & Anniversaries
              </div>
              <ul
                class="bg-white nav text-center d-flex px-2 justify-content-between pt-3 pb-1"
                id="myTab"
              >
                <li class="nav-item" role="presentation">
                  <button
                    class="btn btn-primary bg-main2 fs-14 px-3 btn-padding active"
                    id="birthday-tab"
                    data-toggle="tab"
                    href="#birthday"
                    type="button"
                    role="tab"
                    aria-controls="birthday"
                    aria-selected="true"
                  >
                    Birthdays
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="btn btn-outline-secondary px-3 fs-14 btn-padding"
                    id="anniversary-tab"
                    data-toggle="tab"
                    href="#anniversary"
                    type="button"
                    role="tab"
                    aria-controls="anniversary"
                    aria-selected="false"
                  >
                    Anniversaries
                  </button>
                </li>
              </ul>
              <div
                class="bg-white text-center tab-content border-down approval-card pb-1"
                id="myTabContent"
              >
                <div
                  class="pt-1 tab-pane fade show active"
                  id="birthday"
                  role="tabpanel"
                  aria-labelledby="birthday-tab"
                >
                  <div *ngIf="bDayCount != 0; else nobday">
                    <div
                      class="card-header1 pt-1"
                      *ngFor="let bday of bDayData"
                    >
                      <div class="shadow-main border-down border-up">
                        <div class="bg-light-blue border-up">
                          <img
                            src="assets/img/bday-deco2.webp"
                            class="img-fluid"
                            alt=""
                          />
                        </div>
                        <div
                          class="card-body position-relative bg-light-blue border-down pt-0 pb-1"
                        >
                          <p class="pt-03 mb-1 fs-12 fw-500">
                            {{ bday.month }} , {{ bday.day }}
                          </p>
                          <h6 class="font-weight-bold mb-1">Happy Birthday</h6>
                          <img
                            width="36"
                            [src]="bday.emp_img"
                            onError="src = 'assets/img/profile.webp'"
                          />
                          <p class="fs-11 fw-600 mb-1">{{ bday.EmpName }}</p>
                          <button
                            type="button"
                            class="bg-main2 btn-abso2"
                            (click)="sendWish(bday, '#wish_bday', 1)"
                          >
                            Send Wish
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      class="text-center mb-1"
                      *ngIf="bDayCount != 0 && !isLastBday"
                    >
                      <button
                        type="button"
                        class="btn bg-main2 fs-12 text-white px-2 py-0"
                        (click)="moreBday()"
                      >
                        View more Birthdays
                      </button>
                    </div>
                  </div>
                  <ng-template #nobday>
                    <div class="no-data-card">
                      <h5 class="text-center">
                        <!-- {{ "No Birthdays Today." | translate }} -->
                        <img src="assets/img/no-birthday.png" class="img_sec" />
                      </h5>
                    </div>
                  </ng-template>
                </div>
                <div
                  class="pt-2 tab-pane fade"
                  id="anniversary"
                  role="tabpanel"
                  aria-labelledby="anniversary-tab"
                >
                  <div *ngIf="annvrsryCount != 0; else noannvrs">
                    <div
                      class="card-header1 pt-1"
                      *ngFor="let data of annivrsryData"
                    >
                      <div class="shadow-main border-down border-up">
                        <div class="bg-light-blue border-up">
                          <img
                            src="assets/img/bday-deco.png"
                            class="img-fluid"
                            alt=""
                          />
                        </div>
                        <div
                          class="card-body position-relative bg-light-blue border-down pt-0 pb-1"
                        >
                          <p class="pt-03 mb-1 fs-12 fw-500">
                            {{ data.month }} , {{ data.day }}
                          </p>
                          <h6 class="font-weight-bold mb-1">
                            Happy Anniversary
                          </h6>
                          <img
                            width="36"
                            [src]="data.emp_img"
                            onError="src = 'assets/img/profile.webp'"
                          />
                          <p class="fs-11 fw-600 mb-1">{{ data.EmpName }}</p>
                          <button
                            type="button"
                            class="bg-main2 btn-abso2"
                            (click)="sendWish(data, '#wish_bday', 2)"
                          >
                            Send Wish
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="text-center mb-5"
                    *ngIf="annvrsryCount != 0 && !isLastAvrsry"
                  >
                    <button
                      type="button"
                      class="btn bg-main2 text-white px-2 py-1"
                      (click)="moreAnniversary()"
                    >
                      View more Anniversaries
                    </button>
                  </div>
                  <ng-template #noannvrs>
                    <div class="no-data-card">
                      <h5 class="text-center">
                        <!-- {{ "No Work Anniversaries Today." | translate }} -->
                        <img src="assets/img/no-anni.png" class="img_sec" />
                      </h5>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>

            <div class="mt-3 card-home">
              <div class="card-header1 heading1 border-up bg-main">Queries</div>
              <ul
                class="bg-white nav text-center d-flex px-1 justify-content-between pt-3"
                id="myTab"
              >
                <li class="nav-item" role="presentation">
                  <button
                    class="btn btn-primary bg-main2 fs-14 px-3 btn-padding active"
                    id="myquery-tab"
                    data-toggle="tab"
                    href="#myquery"
                    type="button"
                    role="tab"
                    aria-controls="myquery"
                    aria-selected="true"
                  >
                    My Queries
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="btn btn-outline-secondary px-3 fs-14 btn-padding"
                    id="assignquery-tab"
                    data-toggle="tab"
                    href="#assignquery"
                    type="button"
                    role="tab"
                    aria-controls="assignquery"
                    aria-selected="false"
                  >
                    Assigned Quer..
                  </button>
                </li>
              </ul>
              <div
                class="bg-white text-center tab-content border-down"
                id="myTabContent"
              >
                <div
                  class="tab-pane fade show active"
                  id="myquery"
                  role="tabpanel"
                  aria-labelledby="myquery-tab"
                >
                  <div
                    *ngIf="qrycount != 0; else nomyquery"
                    class="bg-white pt-1 card-header1 border-down pb-3"
                  >
                    <ng-container
                      *ngFor="let item of myQueryData; let aqdId = index"
                    >
                      <div
                        class="shadow-main border-down border-up mt-3 pt-2"
                        (click)="editQuery(item, 'MY')"
                        style="cursor: pointer"
                        [attr.id]="'aqd' + aqdId"
                      >
                        <span
                          class="pull-right clickable close-icon pr-2 text-secondary"
                          data-effect="fadeOut"
                          data-dismiss="alert"
                          [attr.data-target]="'#aqd' + aqdId"
                          type="button"
                          aria-label="Close"
                          ><img
                            src="assets/new_icon/close.svg"
                            class="icon-main"
                            alt="sodexo"
                        /></span>
                        <div class="position-relative d-inline my_q">
                          <button class="btn-warning-dark rounded-right pl-3">
                            {{ "My Query" | translate }}
                            <span
                              class="text-light badgesetting3 badge rounded-pill bg-danger"
                            >
                              {{ qrycount }}
                            </span>
                          </button>
                        </div>
                        <div class="card-body border-down pt-0 pb-1">
                          <p class="pt-03 mb-1 fs-12 fw-500 tab-text">
                            {{ item.qry_id }} | {{ item.username }} -
                            {{ item.name }} | {{ item.cat_desc }} |
                            {{ item.subcat1_desc }} |
                            <span
                              *ngIf="item.log_date != '0000-00-00 00:00:00'"
                              >{{ item.log_date | date : "d-LLL-y" }}</span
                            >
                            |
                            <span
                              *ngIf="item.rslv_date != '0000-00-00 00:00:00'"
                              >{{ item.rslv_date | date : "d-LLL-y" }}</span
                            >
                            | {{ item.cc_desc }} | {{ item.stage_desc }}
                          </p>
                        </div>
                        <div
                          class="approval mt-1 text-center font-weight-bolder col-md-12 border-top"
                        >
                          <!-- <div class="row">
                  <div class="col-md-6 border-right fs-12 pt-2 pb-2">
                    Approve
                  </div>
                  <div class="col-md-6 pt-2 pb-2 fs-12">Decline</div>
                </div> -->
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <ng-template #nomyquery>
                    <div class="no-data-card">
                      <h5 class="text-center">
                        {{ "No Query Created Yet." | translate }}
                      </h5>
                    </div>
                  </ng-template>
                </div>
                <div
                  class="tab-pane fade"
                  id="assignquery"
                  role="tabpanel"
                  aria-labelledby="assignquery-tab"
                >
                  <div
                    *ngIf="assignQueryLength != 0; else noassignquery"
                    class="bg-white pt-1 card-header1 border-down pb-3"
                  >
                    <ng-container
                      *ngFor="let item of assignQueryData; let aqdId = index"
                    >
                      <div
                        class="shadow-main border-down border-up mt-3 pt-2"
                        (click)="editQuery(item, 'ASSIGN')"
                        style="cursor: pointer"
                        [attr.id]="'aqd' + aqdId"
                      >
                        <span
                          class="pull-right clickable close-icon pr-2 text-secondary"
                          data-effect="fadeOut"
                          data-dismiss="alert"
                          [attr.data-target]="'#aqd' + aqdId"
                          type="button"
                          aria-label="Close"
                          ><img
                            src="assets/new_icon/close.svg"
                            class="icon-main"
                            alt="sodexo"
                        /></span>
                        <div class="position-relative d-inline">
                          <button class="btn-warning-dark rounded-right pl-3">
                            {{ "Assigned Query" | translate }}
                            <span
                              class="text-light badgesetting3 badge rounded-pill bg-danger"
                            >
                              {{ assignQueryLength }}
                            </span>
                          </button>
                        </div>
                        <div class="card-body border-down pt-0 pb-1">
                          <p class="pt-03 mb-1 fs-12 fw-500 tab-text">
                            {{ item.qry_id }} | {{ item.name }} |
                            {{ item.cat_desc }} | {{ item.subcat1_desc }} |
                            <span
                              *ngIf="item.log_date != '0000-00-00 00:00:00'"
                              >{{ item.log_date | date : "d-LLL-y" }}</span
                            >
                            |
                            <span
                              *ngIf="item.rslv_date != '0000-00-00 00:00:00'"
                              >{{ item.rslv_date | date : "d-LLL-y" }}</span
                            >
                            | {{ item.cc_desc }} | {{ item.stage_desc }}
                          </p>
                        </div>
                        <div
                          class="approval mt-1 text-center font-weight-bolder col-md-12 border-top"
                        >
                          <!-- <div class="row">
                <div class="col-md-6 border-right fs-12 pt-2 pb-2">
                  Approve
                </div>
                <div class="col-md-6 pt-2 pb-2 fs-12">Decline</div>
              </div> -->
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <ng-template #noassignquery>
                    <div class="no-data-card">
                      <h5 class="text-center">
                        {{ "No Approval Is Pending." | translate }}
                      </h5>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card-home msg">
              <div class="card-header1 heading1 border-up bg-main">
                Quick Actions
              </div>
              <!--  -->
              <div class="tab_se">
                <div class="col-md-12">
                  <div class="tabn_section">
                    <ul class="nav d-flex">
                      <li
                        class="nav-item"
                        *ngFor="let data of modifyQckKey; let i = index"
                      >
                        <a
                          [href]="'#' + data"
                          [class.active]="i == 0"
                          data-toggle="tab"
                          class="nav-link tab-border mr-3 active"
                          ><i class="fa fa-object-group"></i>
                          {{ modifyQckKeyName[data] }}</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!--  -->
              <section class="col-lg-12 col-md-12 col-sm-12 line-tabs">
                <div class="tab-content">
                  <div
                    *ngFor="let datas of modifyQckKey; let i = index"
                    [id]="datas"
                    [class.fade]="i == 0"
                    [class.active]="i == 0"
                    [class.show]="i == 0"
                    class="row pro-overview tab-pane"
                  >
                    <div class="col-md-12 bg-white pt-4 px-3 border-down">
                      <div class="row pl-2 pr-2">
                        <div
                          class="col-md-3 no-padding1"
                          *ngFor="let data of modifyQuickLink[datas]"
                          (click)="navigate(data)"
                        >
                          <a [title]="data.smnu_desc">
                            <div class="quick-actions">
                              <img
                                [src]="data.icon_path"
                                onError="src = 'assets/img/question.svg'"
                                class="icon-main"
                              />
                              {{
                                data.smnu_desc.length > 9
                                  ? (data.smnu_desc | slice : 0 : 9) + ".."
                                  : (data.smnu_desc | translate)
                              }}
                            </div>
                          </a>
                        </div>
                        <!-- <button mat-raised-button
                              matTooltip="Info about the action"
                              aria-label="Button that displays a tooltip when focused or hovered over">
                          Action
                        </button> -->
                      </div>
                    </div>
                    <div
                      class="col-md-12 bg-white pt-4 px-3 border-down"
                      *ngIf="modifyQuickLinkCopy[datas].length > 12"
                    >
                      <div class="col-md-12 col-12 text-center pb-2">
                        <button
                          type="button"
                          class="btn bg-main2 text-white px-2 py-1"
                          (click)="viewAllMenu(modifyQuickLink[datas], datas)"
                        >
                          View
                          {{
                            modifyQuickLink[datas].length > 12 ? "less" : "more"
                          }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <!-- News Section -->

            <div
              class="mt-3 card-home"
              *ngFor="let data of newsData; let i = index"
            >
              <div
                class="shadow-main text-color-main bg-white border-down border-up border-0 mb-3 pb-2"
              >
                <div class="d-flex px-3 py-3">
                  <img
                    src="assets/new_icon/news_popup.svg"
                    class="icon-main mr-1"
                    alt="sodexo"
                    style="height: 30px"
                  />
                  <p class="mb-0 ml-1">
                    <span class="font-weight-bolder text-start">SoNews</span
                    ><br />
                    Latest News & Happenings at Sodexo!
                  </p>
                </div>
                <div class="card px-3 text-white rounded-0 border-0">
                  <owl-carousel-o
                    [options]="customOptions"
                    *ngIf="data.img_arr.length > 0"
                  >
                    <ng-container *ngFor="let slide of data.img_arr">
                      <ng-template carouselSlide>
                        <img [src]="slide" />
                      </ng-template>
                    </ng-container>
                  </owl-carousel-o>

                  <owl-carousel-o
                    [options]="vdoOptions"
                    *ngIf="data.vdo_arr.length > 0"
                  >
                    <ng-container *ngFor="let slide of data.vdo_arr">
                      <ng-template carouselSlide>
                        <video
                          height="240"
                          controls
                          class="vdoCustom"
                          width="100%"
                        >
                          <source [src]="slide" />
                        </video>
                      </ng-template>
                    </ng-container>
                  </owl-carousel-o>

                  <div
                    class="mt-2"
                    style="height: 300px"
                    *ngIf="data.youtube_files.length > 0"
                  >
                    <span *ngFor="let link of data.youtube_files">
                      <youtube-player videoId="{{ link }}"></youtube-player>
                    </span>
                  </div>

                  <div *ngIf="data.files.length > 0" class="mt-2">
                    <a
                      *ngFor="let attch of data.files; let i = index"
                      [href]="attch"
                      target="_blank"
                    >
                      <div class="btn-group btn-group-sm">
                        <button class="btn-primary">
                          <i class="fa fa-paperclip"></i> Attachment
                          {{ i + 1 }}
                        </button>
                      </div>
                      <br />
                      <br />
                    </a>
                  </div>
                </div>

                <div class="pt-2 px-3 cus-img12">
                  <p>
                    {{ data.news_title }}
                  </p>
                  <div>
                    <p class="mb-2 border-top pt-1">
                      <span
                        class="cursor"
                        [routerLink]="[
                          'news-landing-page/',
                          data.enc_cat_id,
                          data.txn_id
                        ]"
                      >
                        <i class="fa fa-plus color_red"></i> READ MORE
                      </span>
                      &nbsp; &nbsp;
                      <span (click)="pinNews(data)" class="cursor">
                        <img
                          src="assets/img/news/pin.svg"
                          style="width: 12px"
                        />
                        {{ data.can_pin == true ? "PIN" : "Unpin" }}
                      </span>
                      <span
                        class="float-right fw-500 cursor"
                        *ngIf="data.likes_allowed == 1"
                        (click)="likeUnlikeNews(data, 1)"
                      >
                        {{ data.like_desc }}
                        {{ data.like_count }} likes
                        <img
                          src="assets/new_icon/like.svg"
                          class="ancor icon-main ml-3"
                        />
                        <b>
                          {{ data.can_like == true ? "LIKE" : "LIKED" }}</b
                        ></span
                      >
                    </p>
                  </div>

                  <div class="d-flex mt-1 pb-1" *ngIf="data.comment_allwd == 1">
                    <img
                      width="30"
                      [src]="data.emp_img"
                      onError="src = 'assets/img/profile.webp'"
                    />
                    <div class="input-group ml-2">
                      <input
                        type="text"
                        class="form-control bg-light"
                        placeholder="Write a comment..."
                        [(ngModel)]="data.usr_comment"
                        aria-label="Write a comment..."
                        aria-describedby="basic-addon2"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn bg-light btn-outline-secondary py-0 px-2 cursor"
                          (click)="doCommentNews(data, data.txn_id, 1)"
                          type="button"
                        >
                          <img
                            src="assets/new_icon/send.svg"
                            class="icon-main"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex" *ngIf="data.comment_allwd == 1">
                    <p class="mt-2 mb-1 text-color-second">
                      {{ data.comment_count }} comments
                    </p>
                  </div>
                  <div
                    *ngIf="data.comment_count > 0 && data.comment_allwd == 1"
                  >
                    <ul
                      class="list-group list-group-flush pt-0 pb-0"
                      *ngFor="let cmnt of data.comment_arr; let i = index"
                    >
                      <li
                        class="list-group-item border-white pt-1 pb-1 d-flex bg-main border-r-15 mb-2"
                        *ngIf="i < data.commentIndex"
                      >
                        <img
                          height="34"
                          class="mr-2 rounded-circle"
                          [src]="cmnt.emp_img"
                          onError="src = 'assets/img/profile.webp'"
                        />
                        <span>
                          <b>{{ cmnt.name }} {{ cmnt.lname }} </b>
                          <small>{{ cmnt.date }}</small
                          ><br />
                          {{ cmnt.comment }} &nbsp;
                        </span>
                      </li>
                      <span
                        class="d-flex ml-5 cenr"
                        *ngIf="i < data.commentIndex"
                      >
                        <span
                          class="float-right fw-500 cursor mr-2"
                          (click)="likeUnlikeNews(cmnt, 2)"
                        >
                          <b class="pr-2">
                            {{ cmnt.can_like == true ? "Like" : "Liked" }}
                          </b></span
                        >
                        <span
                          class="float-right fw-500 cursor mr-2"
                          (click)="cmnt.show_comment = !cmnt.show_comment"
                        >
                          <b> Reply </b></span
                        >
                      </span>

                      <div
                        class="d-flex border-r-15 pt-1 pb-1 px-3 ml-5 mb-2"
                        *ngIf="cmnt.show_comment == true"
                      >
                        <img
                          width="30"
                          [src]="cmnt.emp_img"
                          onError="src = 'assets/img/profile.webp'"
                        />
                        <div class="input-group ml-2">
                          <input
                            type="text"
                            class="form-control bg-light"
                            placeholder="Send Reply..."
                            [(ngModel)]="cmnt.usr_comment"
                          />
                          <div class="input-group-append cursor">
                            <button
                              class="btn bg-light btn-outline-secondary py-0 px-2"
                              (click)="doCommentNews(cmnt, cmnt.txn_id, 2)"
                              type="button"
                            >
                              <img
                                src="assets/new_icon/send.svg"
                                class="icon-main"
                              />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="mt-2" *ngIf="i < data.commentIndex">
                        <div
                          *ngFor="let rpl of cmnt.reply_arr"
                          class="border-r-15 pt-1 pb-1 px-3 ml-5 bg-main mb-2"
                        >
                          <img
                            height="34"
                            class="mr-2 rounded-circle"
                            [src]="rpl.emp_img"
                            onError="src = 'assets/img/profile.webp'"
                          />
                          <span class="rgr">
                            <b>{{ rpl.name }} {{ rpl.lname }} </b>
                            <small>{{ rpl.date }}</small>
                            <br />
                            {{ rpl.comment }}
                            <br />
                            <br />
                          </span>
                        </div>
                      </div>
                    </ul>

                    <p
                      class="text-color-second ml-auto mb-0 cursor"
                      (click)="viewAllCommentNews(data)"
                      *ngIf="
                        data.comment_count > data.commentIndex &&
                        data.commentIndex <= data.comment_arr.length
                      "
                    >
                      View more comments
                    </p>
                    <p
                      class="text-color-second mb-0 cursor"
                      (click)="hideCommentsNews(data)"
                      *ngIf="
                        data.comment_count > 2 &&
                        data.commentIndex >= data.comment_arr.length
                      "
                    >
                      Hide comments
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="text-center mb-5"
              *ngIf="newsData.length > 0 && !isLastNewsPage"
            >
              <button
                type="button"
                class="btn bg-main2 text-white px-2 py-1"
                (click)="moreNews()"
              >
                View more News
              </button>
            </div>
            <!--end-->
            <div class="mt-3 card-home" *ngFor="let data of awardData">
              <div
                class="shadow-main text-color-main bg-white border-down border-up border-0 mb-3 pb-2"
              >
                <div class="d-flex px-3 py-3">
                  <img
                    src="assets/new_icon/recognition.svg"
                    class="icon-main mr-1"
                    alt="sodexo"
                  />
                  <p class="mb-0 ml-1">
                    <span class="font-weight-bolder text-start"
                      >Recognition</span
                    >
                    for Employee performance <br />{{ data.submit_date }}
                  </p>
                </div>
                <div class="card text-white rounded-0 border-0">
                  <img src="assets/img/recog-banner.png" />
                  <div class="card-img-overlay text-center">
                    <h5 class="font-weight-bold mt-2">{{ data.cat_desc }}</h5>
                    <p class="card-text">FY - {{ data.year }}</p>
                    <img
                      class="img-bottom-over imgHght"
                      [src]="data.emp_img"
                      onError="src = 'assets/img/trophy.webp'"
                    />
                  </div>
                </div>

                <div class="pt-2 px-3 cus-img12">
                  <h6
                    class="font-weight-bold mt-5 mb-0 text-center"
                    style="font-size: medium"
                  >
                    {{ data.emp_name }}
                  </h6>
                  <p class="text-center">
                    {{ data.desig_desc }}, {{ data.emp_cc_name }}
                  </p>
                  <p class="text-center" style="font-size: 16px">
                    {{ data.remark }}
                  </p>
                  <p
                    class="text-center"
                    style="font-size: 16px; font-weight: bold"
                  >
                    By
                  </p>
                  <h6
                    class="font-weight-bold mb-4 text-center"
                    style="font-size: medium"
                  >
                    {{ data.nominated_name }}
                  </h6>

                  <div>
                    <p class="mb-2 border-top pt-1">
                      <b>{{ data.like_desc }} &nbsp;</b>
                      <span
                        class="float-right fw-500"
                        (click)="likeUnlikeAward(data)"
                        >{{ data.like_count }} likes
                        <img
                          src="assets/new_icon/like.svg"
                          class="ancor icon-main ml-3"
                        />
                        <b>
                          {{ data.can_like == true ? "LIKE" : "LIKED" }}</b
                        ></span
                      >
                    </p>
                  </div>

                  <div class="d-flex mt-1 pb-1">
                    <img
                      width="30"
                      [src]="data.emp_img"
                      onError="src = 'assets/img/profile.webp'"
                    />
                    <div class="input-group ml-2">
                      <input
                        type="text"
                        class="form-control bg-light"
                        placeholder="Write a comment..."
                        [(ngModel)]="data.comment"
                        aria-label="Write a comment..."
                        aria-describedby="basic-addon2"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn bg-light btn-outline-secondary py-0 px-2"
                          (click)="doComment(data)"
                          type="button"
                        >
                          <img
                            src="assets/new_icon/send.svg"
                            class="icon-main"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    <p class="mt-2 mb-1 text-color-second">
                      {{ data.comment_count }} comments
                    </p>
                  </div>
                  <div *ngIf="data.comment_count > 0">
                    <ul
                      class="list-group list-group-flush pt-0 pb-0"
                      *ngFor="let cmnt of data.comment_arr; let i = index"
                    >
                      <li
                        class="list-group-item border-white pt-1 pb-1 d-flex bg-main border-r-15 mb-2"
                        *ngIf="i < data.commentIndex"
                      >
                        <img
                          height="34"
                          class="mr-2 rounded-circle"
                          [src]="cmnt.emp_img"
                          onError="src = 'assets/img/profile.webp'"
                        />
                        <span>
                          <b>{{ cmnt.name }} {{ cmnt.lname }} </b>
                          <small>{{ cmnt.date }}</small
                          ><br />
                          {{ cmnt.comment }}
                        </span>
                      </li>
                    </ul>
                    <p
                      class="text-color-second ml-auto mb-0 cursor"
                      (click)="viewAllComment(data)"
                      *ngIf="
                        data.comment_count > data.commentIndex &&
                        data.commentIndex <= data.comment_arr.length
                      "
                    >
                      View more comments
                    </p>
                    <p
                      class="text-color-second mb-0 cursor"
                      (click)="hideComments(data)"
                      *ngIf="
                        data.comment_count > 2 &&
                        data.commentIndex >= data.comment_arr.length
                      "
                    >
                      Hide comments
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="text-center mb-5"
              *ngIf="awardData.length > 0 && !isLastAwardPage"
            >
              <button
                type="button"
                class="btn bg-main2 text-white px-2 py-1"
                (click)="moreAward()"
              >
                View more recognitions
              </button>
            </div>
          </div>
          <div class="col-md-3">
            <!--<div class="mt-3 card-home" cdkDrag>
        <div class="card-header1 heading1 border-up bg-main">
          <p class="position-relative d-inline">
            Leaves & Attendance
            <span
              class="position-absolute text-light badgesetting badge rounded-pill bg-danger"
            >
              {{ mrfApprovalsCount + visitingCardApprovalsCount }}
            </span>
          </p>
          <span
            ><a [routerLink]="" (click)="employeeApprovals()">
              View all</a
            ></span
          >
        </div>
        <div class="button_section">
          <div class="row">
            <div class="col-md-12">
              <div class="text_sec">
                <span>12 November - Deepawali | 14 Novemb</span>
              </div>
            </div>
            <div class="col-md-12 col-12">
              <div class="attendance_btn">
                <button type="button" class="btn btn-info">My Attendance</button>
              </div>
            </div>
            <div class="col-md-12 col-12">
              <div class="row">
                <div class="col-9">
                  <div class="attendance_btn">
                    <p class="text_size">Mispunch in November <span class="color_text_c font_p"> 2 </span></p>
                  </div>
                </div>
                <div class="col-3">
                  <div class="icon_s">
                    <i class="fa fa-angle-down"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-6">
              <div class="attendance_btn attendance_btn2">
                <button type="button" class="btn btn-info">My Leaves</button>
              </div>
            </div>
            <div class="col-md-6 col-6">
              <div class="attendance_btn attendance_btn3">
                <button type="button" class="btn btn-info">Reportee</button>
              </div>
            </div>
          </div>
        </div>-->
            <!-- Leave Section Start -->
            <!--<div class="col-md-12 col-12">
          <div class="leave_section color_a mt-3 py-3 px-3">
            <div class="row">
              <div class="col-7">
                <p class="text_size">Casual Leave</p>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-md-6">
                    <div class="leave_btn">
                      <a href="#" class="btn_info btn_info_1">Nov</a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="leave_btn leave_btn3">
                      <a href="#" class="btn_info btn_info_2">2022</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <p class="text_size mt-2"><span class="font_p">1</span> Available</p>
              </div>
              <div class="col-6">
                <p class="text_size text-right mt-2"><span class="font_p">0</span> Availed</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-12">
          <div class="leave_section color_b mt-2 py-3 px-3">
            <div class="row">
              <div class="col-7">
                <p class="text_size">Privilege Leave</p>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-md-6">
                    <div class="leave_btn">
                      <a href="#" class="btn_info btn_info_1">Nov</a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="leave_btn leave_btn3">
                      <a href="#" class="btn_info btn_info_2">2022</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <p class="text_size mt-2"><span class="font_p">1</span> Available</p>
              </div>
              <div class="col-6">
                <p class="text_size text-right mt-2"><span class="font_p">0</span> Availed</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-12">
          <div class="leave_section color_c mt-2 py-3 px-3">
            <div class="row">
              <div class="col-7">
                <p class="text_size">Casual Leave</p>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-md-6">
                    <div class="leave_btn">
                      <a href="#" class="btn_info btn_info_1">Nov</a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="leave_btn leave_btn3">
                      <a href="#" class="btn_info btn_info_2">2022</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <p class="text_size mt-2"><span class="font_p">1</span> Available</p>
              </div>
              <div class="col-6">
                <p class="text_size text-right mt-2"><span class="font_p">0</span> Availed</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-12">
          <div class="leave_section color_d mt-2 py-3 px-3">
            <div class="row">
              <div class="col-7">
                <p class="text_size">Casual Leave</p>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-md-6">
                    <div class="leave_btn">
                      <a href="#" class="btn_info btn_info_1">Nov</a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="leave_btn leave_btn3">
                      <a href="#" class="btn_info btn_info_2">2022</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <p class="text_size mt-2"><span class="font_p">1</span> Available</p>
              </div>
              <div class="col-6">
                <p class="text_size text-right mt-2"><span class="font_p">0</span> Availed</p>
              </div>
            </div>
          </div>
        </div>-->
            <!-- Leave Section End -->
            <!--<ul
          class="bg-white nav text-center d-flex px-3 justify-content-between pt-3"
          id="myTab"
        >
          <li class="nav-item" role="presentation">
            <button
              class="btn btn-outline-main fs-11 px-2 py-1 mb-1 active"
              id="wrf-ap-tab"
              data-toggle="tab"
              href="#wrf-ap"
              type="button"
              role="tab"
              aria-controls="wrf-ap"
              aria-selected="true"
            >
              WRF
            </button>
          </li>
        
          <li class="nav-item" role="presentation">
            <button
              class="btn btn-outline-main px-2 py-1 fs-11 mb-1"
              id="vca-ap-tab"
              data-toggle="tab"
              href="#vca-ap"
              type="button"
              role="tab"
              aria-controls="vca-ap"
              aria-selected="false"
            >
              BCA
            </button>
          </li>
        </ul>

        <div
          class="bg-white pt-1 card-header1 border-down pb-3 tab-content"
          id="myTabContent"
        >
          <div
            class="tab-pane fade show active"
            id="wrf-ap"
            role="tabpanel"
            aria-labelledby="wrf-ap-tab"
          >
            <div *ngIf="mrfApprovalsCount > 0">
              <div
                class="shadow-main border-down border-up mt-3 pt-2"
                *ngFor="let appr of mrfApprovals; let mrfId = index"
                [attr.id]="'mrf' + mrfId"
              >
                <span
                  class="pull-right clickable close-icon pr-2 text-secondary"
                  data-effect="fadeOut"
                  data-dismiss="alert"
                  [attr.data-target]="'#mrf' + mrfId"
                  type="button"
                  aria-label="Close"
                  ><img
                    src="assets/new_icon/close.svg"
                    class="icon-main"
                    alt="sodexo"
                /></span>
                <div class="position-relative d-inline">
                  <button
                    class="btn-success-dark rounded-right pl-3"
                    [routerLink]="['/talent/mrf-details', appr.mrf_enc_id]"
                  >
                    WRF Approval
                    <span
                      class="text-light badgesetting3 badge rounded-pill bg-danger"
                    >
                      {{ mrfApprovalsCount }}
                    </span>
                  </button>
                </div>
                <div class="card-body border-down pt-0 pb-1 px-0 fs-11">
                  <div class="row">
                    <div class="col-6 fw-600">WRF ID</div>
                    <div class="col-6 mb-1">{{ appr.mrf_code }}</div>
                    <div class="col-6 fw-600">Cost Center</div>
                    <div class="col-6 mb-1">{{ appr.cc_desc }}</div>
                    <div class="col-6 fw-600">Type</div>
                    <div class="col-6 mb-1">{{ appr.mrf_type }}</div>
                    <div class="col-6 fw-600">Category</div>
                    <div class="col-6 mb-1">{{ appr.emp_cate }}</div>
                    <div class="col-6 fw-600">Skill</div>
                    <div class="col-6 mb-1">{{ appr.skill_type }}</div>
                    <div class="col-6 fw-600">Designation</div>
                    <div class="col-6 mb-1">{{ appr.desig_desc }}</div>
                  </div>
                 
                </div>
                <div
                  class="approval mt-1 text-center font-weight-bolder col-md-12 border-top"
                >
                  <div class="row">
                    <div
                      class="col-md-6 border-right fs-12 pt-2 pb-2 ancor"
                      (click)="
                        submitMrfApprove(
                          appr.rel_id,
                          appr.approve_id,
                          appr.rel_group_id,
                          appr.txn_id
                        )
                      "
                    >
                      Approve
                    </div>
                    <div
                      class="col-md-6 pt-2 pb-2 fs-12 ancor"
                      (click)="
                        submitMrfApprove(
                          appr.rel_id,
                          appr.reject_id,
                          appr.rel_group_id,
                          appr.txn_id
                        )
                      "
                    >
                      Decline
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="no-data-card" *ngIf="mrfApprovalsCount == 0">
              <h5 class="text-center">
                {{ "No MRF Approval is Pending." | translate }}
              </h5>
            </div>
          </div>

          
          <div
            class="tab-pane fade"
            id="vca-ap"
            role="tabpanel"
            aria-labelledby="vca-ap-tab"
          >
            <div *ngIf="visitingCardApprovalsCount > 0">
              <div
                class="shadow-main border-down border-up mt-3 pt-1"
                *ngFor="let item of visitingCardApprovals; let vcaId = index"
                [attr.id]="'vca' + vcaId"
              >
                <span
                  class="pull-right clickable close-icon pr-2 text-secondary"
                  data-effect="fadeOut"
                  data-dismiss="alert"
                  [attr.data-target]="'#vca' + vcaId"
                  type="button"
                  aria-label="Close"
                  ><img
                    src="assets/new_icon/close.svg"
                    class="icon-main"
                    alt="sodexo"
                /></span>
                <div class="position-relative d-inline">
                  <button class="btn-warning-dark rounded-right px-3">
                    {{ "Business Card Approvals" | translate }}
                  </button>
                  <span
                    class="position-absolute text-light badgesetting badge rounded-pill bg-danger"
                  >
                    {{ visitingCardApprovalsCount }}
                  </span>
                </div>
                <div class="card-body border-down pt-0 pb-1">
                  <p class="pt-03 mb-1 fs-12 fw-500 tab-text">
                    {{ item.cc_ext_id }} - {{ item.cc_desc }} |
                    {{ item.emp_username }}-{{ item.emp_name }}
                    {{ item.emp_lname }} | {{ item.mobile }} |
                    {{ item.no_of_vstng }} Boxes of Business Cards
                  </p>
                </div>
                <div
                  class="approval mt-1 text-center font-weight-bolder col-md-12 border-top"
                >
                  <div class="row">
                    <div
                      class="col-md-6 border-right fs-12 pt-2 pb-2"
                      (click)="
                        submitVisitingCardApprove(item.rel_id, item.req_id, 1)
                      "
                    >
                      Approve
                    </div>
                    <div
                      class="col-md-6 pt-2 pb-2 fs-12"
                      (click)="
                        submitVisitingCardApprove(item.rel_id, item.req_id, 0)
                      "
                    >
                      Decline
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="no-data-card" *ngIf="visitingCardApprovalsCount == 0">
              <h5 class="text-center">
                {{ "No Business Card is Pending for Approval." | translate }}
              </h5>
            </div>
          </div>
        </div>
      </div>-->

            <!-- <div class="card-home" cdkDrag> -->
            <div class="card-home">
              <div class="card-header1 heading1 border-up bg-main">
                <p class="position-relative d-inline">Leaves & Attendance</p>
                <span
                  ><a [routerLink]="" (click)="leaveApprovals()">
                    View all</a
                  ></span
                >
              </div>
              <div class="px-0 bg-white">
                <!-- <mat-calendar [dateClass]="dateClass"></mat-calendar> -->

                <!-- Calender -->
                <ng-container *ngIf="calenderData.length > 0">
                  <div class="month">
                    <ul>
                      <!-- <li class="prev">&#10094;</li>
                    <li class="next">&#10095;</li> -->
                      <li>{{ calShortMonthName }} {{ calYear }}</li>
                    </ul>
                  </div>

                  <ul class="weekdays">
                    <li>Mo</li>
                    <li>Tu</li>
                    <li>We</li>
                    <li>Th</li>
                    <li>Fr</li>
                    <li>Sa</li>
                    <li>Su</li>
                  </ul>

                  <ul class="days">
                    <ng-container *ngFor="let cal of calenderData">
                      <li
                        *ngIf="cal.label == 'Absent'"
                        [class]="cal.class"
                        [title]="cal.label"
                        style="cursor: pointer"
                      >
                        <a [routerLink]="" (click)="goToAttendance()">
                          {{ cal.day }}</a
                        >
                      </li>
                      <li
                        *ngIf="cal.label != 'Absent'"
                        [class]="cal.class"
                        [title]="cal.label"
                        style="cursor: default"
                      >
                        {{ cal.day }}
                      </li>
                    </ng-container>
                    <!-- <li class="border_green">2</li>
                  <li class="border_green">3</li>
                  <li class="border_green">4</li>
                  <li class="border_red">5</li>
                  <li>6</li>
                  <li>7</li>
                  <li class="border_yellow">8</li>
                  <li>9</li>
                  <li class="border_yellow">10</li>
                  <li class="border_green">11</li>
                  <li class="border_green">12</li>
                  <li>13</li>
                  <li>14</li>
                  <li class="border_yellow">15</li>
                  <li class="border_green">16</li>
                  <li class="border_green">17</li>
                  <li>18</li>
                  <li>19</li>
                  <li>20</li>
                  <li>21</li>
                  <li>22</li>
                  <li>23</li>
                  <li>24</li>
                  <li>25</li>
                  <li>26</li>
                  <li>27</li>
                  <li>28</li>
                  <li>29</li>
                  <li>30</li>
                  <li>31</li> -->
                  </ul>
                  <!-- calender -->

                  <ul
                    style="
                      display: flex;
                      justify-content: space-between;
                      text-align: left;
                      padding: 0px;
                    "
                  >
                    <li>
                      <span
                        class="dot"
                        style="background-color: rgb(3, 236, 127)"
                      ></span>
                      Present
                    </li>
                    <li>
                      <span
                        class="dot"
                        style="background-color: #f93c3ccc"
                      ></span>
                      Absent
                    </li>
                    <li>
                      <span class="dot" style="background-color: orange"></span>
                      Leaves
                    </li>
                  </ul>
                </ng-container>
                <!-- <button
                  class="btn btn-primary bg-main2 fs-14 py-1 px-5 mt-3 mb-2"
                  type="button"
                >
                  My Attendance
                </button>
                <p class="font-weight-bolder mb-0 pb-2 border-bottom">
                  Mispunch in November <span class="mx-2 text-danger">2</span>
                  <i
                    class="font-weight-bold ml-3 fa fa-angle-down"
                    aria-hidden="true"
                  ></i>
                </p> -->
              </div>
              <ul
                class="bg-white nav text-center d-flex px-4 justify-content-between pt-3"
                id="myTab"
                role="tablist"
              >
                <li class="nav-item" role="presentation">
                  <button
                    class="btn btn-primary bg-main2 fs-14 px-3 btn-padding active"
                    id="myleave-tab"
                    data-toggle="tab"
                    href="#myleave"
                    type="button"
                    role="tab"
                    aria-controls="myleave"
                    aria-selected="true"
                  >
                    My Leaves
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="btn btn-outline-secondary px-3 fs-14 btn-padding"
                    id="reportee-tab"
                    data-toggle="tab"
                    href="#reportee"
                    type="button"
                    role="tab"
                    aria-controls="reportee"
                    aria-selected="false"
                  >
                    Reportee
                  </button>
                </li>
              </ul>
              <div class="bg-white tab-content border-down" id="myTabContent">
                <div
                  class="tab-pane fade show active"
                  id="myleave"
                  role="tabpanel"
                  aria-labelledby="myleave-tab"
                >
                  <div class="px-4 pt-1">
                    <ng-container *ngIf="mainLeaves.length > 0; else noleave">
                      <div
                        class="card border-left-main margin-12 shadow-main rounded-0 border-top-0 border-right-0 border-bottom-0"
                        *ngFor="let bal of mainLeaves"
                      >
                        <div class="card-body py-1 px-2">
                          <div class="row no-gutters align-items-center">
                            <div class="col">
                              <div class="tab-text mb-1">
                                {{ bal.lv_desc }}
                                <span class="float-right">
                                  <button
                                    type="button"
                                    class="bg-main2 btnspandark mr-1"
                                  >
                                    {{ bal.monthName }}
                                  </button>
                                  <button type="button" class="btnspanlight">
                                    {{ bal.year }}
                                  </button>
                                </span>
                              </div>
                              <div class="d-flex">
                                <div class="tab-text-light mb-0">
                                  <span
                                    class="text-success font-weight-bolder"
                                    >{{ bal.available }}</span
                                  >
                                  Available
                                </div>
                                <div class="tab-text-light mb-0 ml-auto">
                                  <span
                                    class="text-success font-weight-bolder"
                                    >{{ bal.availed }}</span
                                  >
                                  Availed
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #noleave
                      >You have insufficient leave balance</ng-template
                    >
                  </div>
                  <div
                    class="mt-3 text-center font-weight-bolder col-md-12 border-top"
                  >
                    <div class="row">
                      <div
                        *ngIf="ftcRistrict"
                        class="col-md-6 border-right pt-2 pb-2 ancor"
                        (click)="addEmployeeLeave()"
                      >
                        + Apply Leave
                      </div>
                      <div
                        class="col-md-6 pt-2 pb-2 ancor"
                        (click)="goToAttendance()"
                      >
                        Attendance
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade px-4 pt-1 pb-3"
                  id="reportee"
                  role="tabpanel"
                  aria-labelledby="reportee-tab"
                >
                  <div class="input-group mb-3">
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="username"
                      placeholder="Please enter the user id"
                      aria-label="user id"
                      aria-describedby="button-addon2"
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-secondary btn-sm"
                        type="button"
                        id="button-addon2"
                        (click)="reportiesLeave()"
                      >
                        Search
                      </button>
                    </div>
                  </div>
                  <ng-container
                    *ngIf="reportLeavesCount.length > 0; else noReportiesLeave"
                  >
                    <div
                      class="card border-left-main margin-12 shadow-main rounded-0 border-top-0 border-right-0 border-bottom-0"
                      *ngFor="let bal of reportLeavesCount"
                    >
                      <div class="card-body py-1 px-2">
                        <div class="row no-gutters align-items-center">
                          <div class="col">
                            <div class="tab-text mb-1">
                              {{ bal.lv_desc }}
                              <span class="float-right">
                                <button
                                  type="button"
                                  class="bg-main2 btnspandark"
                                >
                                  {{ bal.monthName }}
                                </button>
                                <button type="button" class="btnspanlight">
                                  {{ bal.year }}
                                </button>
                              </span>
                            </div>
                            <div class="d-flex">
                              <div class="tab-text-light mb-0">
                                <span class="text-success font-weight-bolder">{{
                                  bal.available
                                }}</span>
                                Available
                              </div>
                              <div class="tab-text-light mb-0 ml-auto">
                                <span class="text-success font-weight-bolder">{{
                                  bal.availed
                                }}</span>
                                Availed
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #noReportiesLeave>{{
                    reportiesLeaveMsg
                  }}</ng-template>
                </div>
              </div>
            </div>

            <!-- <div class="mt-3 card-home" cdkDrag>
              <div class="card-header1 heading1 border-up bg-main">
                <p class="position-relative d-inline">
                  Approvals
                  <span
                    class="position-absolute text-light badgesetting badge rounded-pill bg-danger"
                  >
                    {{
                      mrfApprovalsCount +
                        napsMrfApprovalsCount +
                        awardApprovalsCount +
                        idCardApprovalsCount +
                        epaApprovalsCount +
                        workPlaceApprovalsCount +
                        pettyCashApprovalCount +
                        pettyCashExpenseApprovalCount +
                        visitingCardApprovalsCount +
                        transferApprovalsCount +
                        ongcpassCount
                    }}
                  </span>
                </p>
                <span><a (click)="showAllApproval()"> View all</a></span>
              </div>
              <ul
                class="bg-white nav text-center d-flex px-3 justify-content-between pt-3"
                id="myTab"
              >
                <li class="nav-item" role="presentation">
                  <button
                    class="btn btn-outline-main fs-11 px-2 py-1 mb-1 active"
                    id="wrf-ap-tab"
                    data-toggle="tab"
                    href="#wrf-ap"
                    type="button"
                    role="tab"
                    aria-controls="wrf-ap"
                    aria-selected="true"
                  >
                    MRF
                  </button>
                </li>

                <li class="nav-item" role="presentation">
                  <button
                    class="btn btn-outline-main px-2 py-1 fs-11 mb-1"
                    id="vca-ap-tab"
                    data-toggle="tab"
                    href="#vca-ap"
                    type="button"
                    role="tab"
                    aria-controls="vca-ap"
                    aria-selected="false"
                  >
                    BCA
                  </button>
                </li>
              </ul>

              <div
                class="bg-white pt-1 card-header1 border-down pb-3 tab-content"
                id="myTabContent"
              >
                <div
                  class="tab-pane fade show active"
                  id="wrf-ap"
                  role="tabpanel"
                  aria-labelledby="wrf-ap-tab"
                >
                  <div *ngIf="mrfApprovalsCount > 0">
                    <div
                      class="shadow-main border-down border-up mt-3 pt-2"
                      *ngFor="let appr of mrfApprovals; let mrfId = index"
                      [attr.id]="'mrf' + mrfId"
                    >
                      <span
                        class="pull-right clickable close-icon pr-2 text-secondary"
                        data-effect="fadeOut"
                        data-dismiss="alert"
                        [attr.data-target]="'#mrf' + mrfId"
                        type="button"
                        aria-label="Close"
                        ><img
                          src="assets/new_icon/close.svg"
                          class="icon-main"
                          alt="sodexo"
                      /></span>
                      <div class="position-relative d-inline">
                        <button
                          class="btn-success-dark rounded-right mb-1 pl-3"
                          [routerLink]="[
                            '/talent/mrf-details',
                            appr.mrf_enc_id
                          ]"
                        >
                          MRF Approval
                          <span
                            class="text-light badgesetting3 badge rounded-pill bg-danger"
                          >
                            {{ mrfApprovalsCount }}
                          </span>
                        </button>
                      </div>
                      <div
                        class="card-body border-down px-2 pt-0 pb-1 px-0 fs-11"
                      >
                        <div class="row">
                          <div class="col-6 fw-600">MRF ID</div>
                          <div class="col-6 mb-1">{{ appr.mrf_code }}</div>
                          <div class="col-6 fw-600">Cost Center</div>
                          <div class="col-6 mb-1">{{ appr.cc_desc }}</div>
                          <div class="col-6 fw-600">Type</div>
                          <div class="col-6 mb-1">{{ appr.mrf_type }}</div>
                          <div class="col-6 fw-600">Category</div>
                          <div class="col-6 mb-1">{{ appr.emp_cate }}</div>
                          <div class="col-6 fw-600">Skill</div>
                          <div class="col-6 mb-1">{{ appr.skill_type }}</div>
                          <div class="col-6 fw-600">Designation</div>
                          <div class="col-6 mb-1">{{ appr.desig_desc }}</div>
                        </div>
                      </div>
                      <div
                        class="approval mt-1 text-center font-weight-bolder col-md-12 border-top"
                      >
                        <div class="row">
                          <div
                            class="col-md-6 border-right fs-12 pt-2 pb-2 ancor"
                            (click)="
                              submitMrfApprove(
                                appr.rel_id,
                                appr.approve_id,
                                appr.rel_group_id,
                                appr.txn_id
                              )
                            "
                          >
                            <button
                              type="button"
                              class="btn btn-labeled btn-success"
                            >
                              <span class="btn-label"
                                ><i class="fa fa-check"></i></span
                              >Approve
                            </button>
                          </div>
                          <div
                            class="col-md-6 pt-2 pb-2 fs-12 ancor"
                            (click)="
                              submitMrfApprove(
                                appr.rel_id,
                                appr.reject_id,
                                appr.rel_group_id,
                                appr.txn_id
                              )
                            "
                          >
                            <button
                              type="button"
                              class="btn btn-labeled btn-danger"
                            >
                              <span class="btn-label"
                                ><i class="fa fa-remove"></i></span
                              >Decline
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="no-data-card" *ngIf="mrfApprovalsCount == 0">
                    <h5 class="text-center">
                      {{ "No MRF Approval is Pending." | translate }}
                    </h5>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="vca-ap"
                  role="tabpanel"
                  aria-labelledby="vca-ap-tab"
                >
                  <div *ngIf="visitingCardApprovalsCount > 0">
                    <div
                      class="shadow-main border-down border-up mt-3 pt-1"
                      *ngFor="
                        let item of visitingCardApprovals;
                        let vcaId = index
                      "
                      [attr.id]="'vca' + vcaId"
                    >
                      <span
                        class="pull-right clickable close-icon pr-2 text-secondary"
                        data-effect="fadeOut"
                        data-dismiss="alert"
                        [attr.data-target]="'#vca' + vcaId"
                        type="button"
                        aria-label="Close"
                        ><img
                          src="assets/new_icon/close.svg"
                          class="icon-main"
                          alt="sodexo"
                      /></span>
                      <div class="position-relative d-inline">
                        <button class="btn-warning-dark rounded-right px-3">
                          {{ "Business Card Approvals" | translate }}
                        </button>
                        <span
                          class="position-absolute text-light badgesetting badge rounded-pill bg-danger"
                        >
                          {{ visitingCardApprovalsCount }}
                        </span>
                      </div>
                      <div class="card-body border-down pt-0 pb-1">
                        <p class="pt-03 mb-1 fs-12 fw-500 tab-text">
                          {{ item.cc_ext_id }} - {{ item.cc_desc }} |
                          {{ item.emp_username }}-{{ item.emp_name }}
                          {{ item.emp_lname }} | {{ item.mobile }} |
                          {{ item.no_of_vstng }} Boxes of Business Cards
                        </p>
                      </div>
                      <div
                        class="approval mt-1 text-center font-weight-bolder col-md-12 border-top"
                      >
                        <div class="row">
                          <div
                            class="col-md-6 border-right fs-12 pt-2 pb-2"
                            (click)="
                              submitVisitingCardApprove(
                                item.rel_id,
                                item.req_id,
                                1
                              )
                            "
                          >
                            Approve
                          </div>
                          <div
                            class="col-md-6 pt-2 pb-2 fs-12"
                            (click)="
                              submitVisitingCardApprove(
                                item.rel_id,
                                item.req_id,
                                0
                              )
                            "
                          >
                            Decline
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="no-data-card"
                    *ngIf="visitingCardApprovalsCount == 0"
                  >
                    <h5 class="text-center">
                      {{
                        "No Business Card is Pending for Approval." | translate
                      }}
                    </h5>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="mt-3 card-home">
              <div class="card-header1 heading1 border-up bg-main">
                <p class="position-relative d-inline">
                  Hot Jobs
                  <span
                    class="position-absolute text-light badgesetting badge rounded-pill bg-danger"
                  >
                    {{ countR + countF }}
                  </span>
                </p>
                <span
                  ><a [routerLink]="['/talent/internal-jobs']"
                    >view all</a
                  ></span
                >
              </div>
              <ul
                class="bg-white nav text-center d-flex px-1 justify-content-between pt-3"
                id="myTab"
              >
                <li class="nav-item" role="presentation">
                  <button
                    class="btn btn-primary bg-main2 fs-14 px-3 btn-padding active"
                    id="ftpjobs-tab"
                    data-toggle="tab"
                    href="#ftpjobs"
                    type="button"
                    role="tab"
                    aria-controls="ftpjobs"
                    aria-selected="true"
                  >
                    FTC Jobs
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="btn btn-outline-secondary px-3 fs-14 btn-padding"
                    id="regularjobs-tab"
                    data-toggle="tab"
                    href="#regularjobs"
                    type="button"
                    role="tab"
                    aria-controls="regularjobs"
                    aria-selected="false"
                  >
                    Regular Jobs
                  </button>
                </li>
              </ul>
              <div class="bg-white tab-content border-down" id="myTabContent">
                <div
                  class="tab-pane fade show active"
                  id="ftpjobs"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <div
                    class="card-header1 pb-3 approval-card"
                    *ngIf="countF != 0"
                  >
                    <div
                      class="card-home mb-3"
                      *ngFor="let list of ijpListFTC | slice : 0 : 5"
                    >
                      <div class="card-header2 heading2 border-up bg-main">
                        {{ list.ijp_code }}
                        <span>{{ list.created_at }}</span>
                      </div>
                      <div
                        class="card-header2 bg-white border-down border-0 pt-2"
                      >
                        <h5>{{ list.desig_desc }}</h5>
                        <div class="mt-1 col-md-12">
                          <div class="row">
                            <div class="col-md-6 fs-12 p-0">
                              <img
                                class="icon-main"
                                src="assets/new_icon/experience.svg"
                              />
                              {{ list.exp_frm }} - {{ list.exp_to }} Years
                            </div>
                            <div class="col-md-6 p-0 fs-12">
                              <img
                                class="icon-main"
                                src="assets/new_icon/location.svg"
                              />

                              {{ list.cost_center }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="p-1 text-center border-top font-weight-bolder"
                      >
                        <a
                          href="javascript:void(0);"
                          [routerLink]="[
                            '/quick-links/internal-jobs/' + list.mrf_id
                          ]"
                        >
                          know more <i class="fa fa-angle-right"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="no-data-card" *ngIf="countF == 0">
                    <h5 class="text-center">
                      {{ "No FTC Jobs." | translate }}
                    </h5>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="regularjobs"
                  role="tabpanel"
                  aria-labelledby="regularjobs-tab"
                >
                  <div
                    class="pb-3 card-header1 approval-card"
                    *ngIf="countR != 0"
                  >
                    <div
                      class="card-home"
                      *ngFor="let list of ijpListReular | slice : 0 : 5"
                    >
                      <div class="card-header2 heading2 border-up bg-main">
                        {{ list.ijp_code }}
                        <span>{{ list.created_at }}</span>
                      </div>
                      <div
                        class="card-header2 bg-white border-down border-0 pt-2"
                      >
                        <h5>{{ list.desig_desc }}</h5>
                        <div class="mt-1 col-md-12">
                          <div class="row">
                            <div class="col-md-12 fs-12 p-0">
                              <img
                                class="icon-main"
                                src="assets/new_icon/experience.svg"
                              />
                              {{ list.exp_frm }} - {{ list.exp_to }} Years
                            </div>
                          </div>
                          <div class="row m-t-5">
                            <div class="col-md-12 p-0 fs-12">
                              <img
                                class="icon-main"
                                src="assets/new_icon/location.svg"
                              />
                              {{ list.cost_center }}
                              <!-- {{
                          list.cost_center.length > 10
                            ? (list.cost_center | slice: 0:10) + "..."
                            : list.cost_center
                        }} -->
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="p-1 text-center border-top font-weight-bolder"
                      >
                        <a
                          href="javascript:void(0);"
                          [routerLink]="[
                            '/quick-links/internal-jobs/' + list.mrf_id
                          ]"
                        >
                          know more <i class="fa fa-angle-right"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="no-data-card" *ngIf="countR == 0">
                    <h5 class="text-center">
                      {{ "No Regular Jobs." | translate }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="popper" *ngIf="wishAnimation == true">
          <img src="assets/new_icon/wishpopper.gif" alt="" />
        </div>
      </div>

      <!--------------------------------------------------------------------------------------------------------------->
      <!-- ---------------approval table row-------------->

      <!--end page body contant -->
    </div>
  </div>
</div>
<!-- /Page Wrapper -->

<!-- employee id card modal window-->

<app-employee-id-card
  [data]="empIDInfo"
  (childEvent)="childOutput($event)"
  *ngIf="hasData"
></app-employee-id-card>

<app-portal-link></app-portal-link>
<!--end employee id card modal window -->

<!-- <div
  id="take_action_expense"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
  style="z-index: 10600 !important ; background: #00000075;"
>
  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
    <div class="modal-content" style="box-shadow: 2px 2px 5px black">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">Take Action</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="onCloseResolveExpense()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form
        [formGroup]="resolveFormExpense"
        (ngSubmit)="onSubmitResolveExpense()"
      >
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="role_name">Action</label>
                <select2
                  [data]="resolveAction"
                  (update)="takeAction($event)"
                  formControlName="is_approved"
                  placeholder="Select Action"
                ></select2>
                <div
                  *ngIf="submitExp && expErrorMsg.is_approved.errors"
                  class="form-error"
                >
                  <div *ngIf="expErrorMsg.is_approved.errors.required">
                    Action is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="cmmntsaward">Comments</label>
                <textarea
                  type="text"
                  formControlName="remark"
                  class="form-control"
                  placeholder="Comments"
                ></textarea>
                <div
                  *ngIf="submitExp && expErrorMsg.remark.errors"
                  class="form-error"
                >
                  <div *ngIf="expErrorMsg.remark.errors.required">
                    Comments is required !
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="submit"
            class="btn btn-primary btn-sm"
            [disabled]="loading"
          >
            <span
              *ngIf="loading"
              class="spinner-border spinner-border-sm mr-1"
            ></span>
            {{ btnName }}
          </button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-dismiss="modal"
            (click)="onCloseResolveExpense()"
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div> -->
<!-- //award -->

<div
  id="take_action_id_card"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
  style="z-index: 10600 !important; background: #00000075"
>
  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
    <div class="modal-content" style="box-shadow: 2px 2px 5px black">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">Take Action</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="onCloseResolve()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form
        [formGroup]="resolveFormIDCard"
        (ngSubmit)="onSubmitResolveIDCard()"
      >
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="role_name">Action</label>
                <select2
                  [data]="resolveAction"
                  (update)="takeAction($event)"
                  formControlName="is_approved"
                  placeholder="Select Action"
                ></select2>
                <div
                  *ngIf="submit && resolveIDCardErrorMsg.is_approved.errors"
                  class="form-error"
                >
                  <div
                    *ngIf="resolveIDCardErrorMsg.is_approved.errors.required"
                  >
                    Action is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="cmmntsaward">Comments</label>
                <textarea
                  type="text"
                  formControlName="remark"
                  class="form-control"
                  placeholder="Comments"
                ></textarea>
                <div
                  *ngIf="submit && resolveIDCardErrorMsg.remark.errors"
                  class="form-error"
                >
                  <div *ngIf="resolveIDCardErrorMsg.remark.errors.required">
                    Comments is required !
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="submit"
            class="btn btn-primary btn-sm"
            [disabled]="loading"
          >
            <span
              *ngIf="loading"
              class="spinner-border spinner-border-sm mr-1"
            ></span>
            {{ btnName }}
          </button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-dismiss="modal"
            (click)="onCloseResolveIDCard()"
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- ACCESSHR TECHNICAL SUPPORT modal  -->

<div
  id="technical-support"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">
          ACCESSHR TECHNICAL SUPPORT
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="onCloseCmplntModal()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form [formGroup]="complaintForm" (ngSubmit)="onSubmitComplaint()">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <p>
                This section has to be used only for TECHNICAL SUPPORT in
                AccessHR portal.
              </p>
              <div class="form-group">
                <label for="module_name">Select Module:</label>
                <select class="form-control" formControlName="module">
                  <option value="">Select</option>
                  <option
                    *ngFor="let data of activeApps"
                    value="{{ data.label }}"
                  >
                    {{ data.label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Subject:</label>
                <input
                  type="text"
                  formControlName="subject"
                  class="form-control"
                  placeholder="Subject"
                />
                <div
                  *ngIf="submitCmplnt && cmplntErrMsg.subject.errors"
                  class="form-error"
                >
                  <div *ngIf="cmplntErrMsg.subject.errors.required">
                    Subject is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Detail Remark:</label>
                <textarea
                  type="text"
                  class="form-control"
                  formControlName="remark"
                  placeholder="Type Remark here"
                ></textarea>
                <div
                  *ngIf="submitCmplnt && cmplntErrMsg.remark.errors"
                  class="form-error"
                >
                  <div *ngIf="cmplntErrMsg.remark.errors.required">
                    Remark is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Upload file:</label>
                <input
                  type="file"
                  class="form-control"
                  formControlName="ticket_screenshot"
                  (change)="onFileChange($event)"
                />
                <div
                  *ngIf="submitCmplnt && cmplntErrMsg.ticket_screenshot.errors"
                  class="form-error"
                >
                  <div *ngIf="cmplntErrMsg.ticket_screenshot.errors.required">
                    Image is required !
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary btn-sm">Submit</button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-dismiss="modal"
            (click)="onCloseCmplntModal()"
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div
  id="approval_modal"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
  style="z-index: 1060 !important"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content" style="box-shadow: 2px 2px 5px black">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">
          Pending Approvals
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-approvals></app-approvals>
      </div>
    </div>
  </div>
</div>

<app-apply-leave [modalCall]="clickEvModal"></app-apply-leave>

<!-- approver modal  -->
<div
  id="employee_approver_modal"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered modal-xxl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title"
          style="margin-bottom: -20px"
          id="zero_country_form_title"
        >
          All Pending Approvals
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <!--  -->

            <!--  -->
            <div class="table-responsive" *ngIf="attRegulariseDataCount > 0">
              <div class="text-center-font">
                Attendance Regularization Approvals
              </div>
              <hr style="background: red" />
              <table class="table table-striped mb-0">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>S.No.</th>
                    <th>Cost Center</th>
                    <th>Date</th>
                    <th>Emp Name</th>
                    <th>Requested Date</th>
                    <th>Attendance</th>
                    <th>In Time</th>
                    <th>Out Time</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of attRegulariseData; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.cc_desc }}</td>
                    <td>{{ item.date }}</td>
                    <td>
                      {{ item.username }} {{ item.name }} {{ item.lname }}
                    </td>
                    <td>{{ item.requested_on }}</td>
                    <td>{{ item.code }}</td>
                    <td>{{ item.in_time }}</td>
                    <td>{{ item.out_time }}</td>
                    <td>
                      <div class="btn-group btn-group-sm d-block">
                        <button
                          type="button"
                          class="btn btn-sm btn-success"
                          (click)="approveRejRegularise(item, 1)"
                        >
                          <i class="fa fa-check" aria-hidden="true"></i> Approve
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-danger"
                          (click)="approveRejRegularise(item, 0)"
                        >
                          <i class="fa fa-user-times" aria-hidden="true"></i>
                          Reject
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--  -->
            <div class="table-responsive" *ngIf="mrfApprovalsCount != 0">
              <div class="text-center-font">MRF Approvals</div>
              <hr style="background: red" />

              <div class="mt-2 mb-2">
                <button
                  type="button"
                  (click)="submitBulkMrfApprove('2')"
                  class="btn btn-primary btn-sm mr-10"
                >
                  <span _ngcontent-spk-c217="" class="btn-label"
                    ><i _ngcontent-spk-c217="" class="fa fa-check"></i
                  ></span>
                  Approve
                </button>
                <button
                  type="button"
                  (click)="submitBulkMrfApprove('7')"
                  class="btn btn-danger btn-sm mr-10"
                >
                  <span _ngcontent-spk-c217="" class="btn-label"
                    ><i _ngcontent-spk-c217="" class="fa fa-remove"></i
                  ></span>
                  Reject
                </button>
              </div>
              <table class="table table-striped mb-0">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>
                      <label class="form-check-label">
                        Select all<br />
                        <input
                          type="checkbox"
                          (change)="checkUncheckAllMRf($event)"
                        />
                      </label>
                    </th>
                    <th>MRF Id</th>
                    <th>Cost Center</th>
                    <th>Hiring Type</th>
                    <th>Designation</th>
                    <th>Status</th>
                    <th>Created ON</th>
                    <th>Created By</th>
                    <th>Require By Date</th>
                    <th>Attachment</th>
                    <th>Approve</th>
                    <th>Reject</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let appr of mrfApprovals">
                    <td>
                      <input type="checkbox" [(ngModel)]="appr.isSelected" />
                    </td>
                    <td>
                      {{ appr.mrf_code }}
                      <a
                        [routerLink]="['/talent/mrf-details', appr.mrf_enc_id]"
                        target="_blank"
                        ><i class="fa fa-eye"></i
                      ></a>
                    </td>
                    <td>{{ appr.cc_desc }}</td>
                    <td>
                      {{ appr.mrf_type }} <br />{{ appr.emp_cate }}<br />
                      {{ appr.skill_type }}
                    </td>
                    <td>
                      {{ appr.desig_desc }}
                      <br />
                      <span *ngIf="appr.level != 0">
                        <b> Level :</b> {{ appr.level_name }}
                      </span>
                    </td>
                    <td>{{ appr.status_desc }}</td>
                    <td>{{ appr.created_at }}</td>
                    <td>{{ appr.name }}</td>
                    <td>{{ appr.reqd_by }}</td>
                    <td class="text-center">
                      <a
                        [href]="appr.attachment"
                        *ngIf="appr.attachment != ''"
                        target="_blank"
                      >
                        <i class="fa fa-paperclip"></i>
                      </a>
                    </td>
                    <td class="text-center">
                      <button
                        class="btn btn-primary btn-sm"
                        (click)="
                          submitMrfApprove(
                            appr.rel_id,
                            appr.approve_id,
                            appr.rel_group_id,
                            appr.txn_id
                          )
                        "
                      >
                        <span class="btn-label"
                          ><i class="fa fa-check"></i></span
                        >Approve
                      </button>
                    </td>
                    <td class="text-center">
                      <button
                        class="btn btn-danger btn-sm"
                        (click)="
                          submitMrfApprove(
                            appr.rel_id,
                            appr.reject_id,
                            appr.rel_group_id,
                            appr.txn_id
                          )
                        "
                      >
                        <span class="btn-label"
                          ><i class="fa fa-remove"></i></span
                        >Reject
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--  -->
            <div class="table-responsive" *ngIf="transferApprovalsCount != 0">
              <div class="text-center-font">Transfer Approvals</div>
              <hr style="background: red" />
              <div class="mt-10">
                <button
                  type="button"
                  (click)="submitBulkTransferApprove('2')"
                  class="btn btn-primary btn-sm mr-10"
                >
                  Approve
                </button>
                <button
                  type="button"
                  (click)="submitBulkTransferApprove('7')"
                  class="btn btn-danger btn-sm mr-10"
                >
                  Reject
                </button>
              </div>
              <table class="table table-striped mb-0">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>
                      <label class="form-check-label">
                        Select all<br />
                        <input
                          type="checkbox"
                          (change)="checkUncheckAllTransfer($event)"
                        />
                      </label>
                    </th>
                    <th>MRF Id / Transfer Type</th>
                    <th>Employee Name</th>
                    <th>IN Cost Center</th>
                    <th>Transfer IN Date</th>
                    <th>Site IN Zone / PF Type</th>
                    <th>Out Cost Center</th>
                    <th>Transfer Out Date</th>
                    <th>Site Out Zone / PF Type</th>
                    <th>Status</th>
                    <th>Created Details</th>
                    <th>Approve / Reject</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let appr of transferApprovals">
                    <td>
                      <input type="checkbox" [(ngModel)]="appr.isSelected" />
                    </td>
                    <td>
                      {{ appr.mrf_code }}
                      <a
                        [routerLink]="[
                          '/talent/mrf-transfer-details',
                          appr.mrf_enc_id
                        ]"
                        target="_blank"
                        ><i class="fa fa-eye"></i
                      ></a>
                      <br />{{ appr.trnsfer_type }} <br />
                      <a
                        [href]="appr.attachment"
                        *ngIf="appr.attachment != ''"
                        target="_blank"
                      >
                        <i class="fa fa-paperclip"></i>
                      </a>
                    </td>
                    <td>{{ appr.emp_name }}</td>
                    <td>{{ appr.cc_desc }}</td>
                    <td>{{ appr.reqd_by }}</td>
                    <td>
                      {{ appr.new_sch_emp }} <br />
                      {{ appr.new_zone }} <br />
                      {{ appr.new_pf_type }}
                    </td>
                    <td>{{ appr.old_cc_desc }}</td>
                    <td>{{ appr.trans_out_date }}</td>
                    <td>
                      {{ appr.old_sch_emp }} <br />
                      {{ appr.old_zone }} <br />
                      {{ appr.old_pf_type }}
                    </td>
                    <td>{{ appr.status_desc }}</td>
                    <td>
                      {{ appr.created_name }} <br />
                      {{ appr.created_at }}
                    </td>
                    <td>
                      <button
                        class="btn btn-primary btn-sm btn-sm-custom"
                        (click)="
                          submitTransferApprove(
                            appr.rel_id,
                            appr.approve_id,
                            appr.rel_group_id,
                            appr.txn_id
                          )
                        "
                      >
                        Approve
                      </button>
                      &nbsp;
                      <button
                        class="btn btn-danger btn-sm btn-sm-custom"
                        (click)="
                          submitTransferApprove(
                            appr.rel_id,
                            appr.reject_id,
                            appr.rel_group_id,
                            appr.txn_id
                          )
                        "
                      >
                        Reject
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-responsive" *ngIf="exitApprovalsCount != 0">
              <div class="text-center-font">Exit Approvals</div>
              <hr style="background: red" />
              <div class="mt-10">
                <button
                  type="button"
                  (click)="submitBulkExitApprove('0')"
                  class="btn btn-danger btn-sm mr-10"
                >
                  Reject
                </button>
                <button
                  type="button"
                  (click)="submitBulkExitApprove('1')"
                  class="btn btn-primary btn-sm mr-10"
                >
                  Approve
                </button>
              </div>
              <table class="table table-striped mb-0">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>
                      <label class="form-check-label">
                        <input
                          type="checkbox"
                          (change)="checkUncheckAllEXIT($event)"
                        />
                        &nbsp;&nbsp;Select all
                      </label>
                    </th>
                    <th>Sr no</th>
                    <th>Cost Center</th>
                    <th>Employee</th>
                    <th>Resignation Date</th>
                    <th>Category</th>
                    <th>Reason</th>
                    <th>Last Working Date</th>
                    <th>On Behalf</th>
                    <th>Is Blacklisted ?</th>
                    <th>Reportiees new reporting manager</th>
                    <th>Attachment</th>
                    <th>Action</th>
                    <th>Update</th>
                    <!-- <th>Approve</th>
                                            <th>Reject</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of exitApprovals; let i = index">
                    <td>
                      <input type="checkbox" [(ngModel)]="data.isSelected" />
                    </td>
                    <td>{{ i + 1 }}</td>
                    <td>{{ data.cost_center }}</td>
                    <td>{{ data.emp_name }}</td>
                    <td>{{ data.exit_init_date }}</td>
                    <td>{{ data.vltry_name }}</td>
                    <td>{{ data.reason_name }}</td>
                    <td>{{ data.exit_nego_date }}</td>
                    <td>
                      <span *ngIf="data.is_exit_on_behalf"
                        >Yes By {{ data.obh_emp_name }}</span
                      >
                      <span *ngIf="!data.is_exit_on_behalf">No</span>
                    </td>
                    <td>
                      <span *ngIf="data.is_blacklist">Yes</span>
                      <span *ngIf="!data.is_blacklist">No</span>
                    </td>
                    <td>{{ data.nrm_emp_name }}</td>
                    <td class="text-center">
                      <a
                        [href]="data.img"
                        *ngIf="data.img != ''"
                        target="_blank"
                      >
                        <i class="fa fa-paperclip"></i>
                      </a>
                    </td>
                    <!-- <td class="text-center"><button class="btn btn-primary btn-sm btn-sm-custom" (click)="submitExitApprove(data.rel_id,data.exit_id, data.approve_id) ">Approve</button></td> -->
                    <td>
                      <button
                        type="button"
                        class="btn btn-primary btn-sm btn-sm-custom"
                        (click)="
                          submitExitApprove(
                            data.rel_id,
                            data.exit_id,
                            data.approve_id,
                            1,
                            data.emp_user_id,
                            data.rel_user_id,
                            data.rel_level,
                            data.reporties_count,
                            data.rpls_rm_id,
                            data.emp_name
                          )
                        "
                      >
                        Approve
                      </button>
                      <br />
                      <button
                        type="button"
                        class="btn btn-danger btn-sm btn-sm-custom m-t-5"
                        (click)="
                          submitExitApprove(
                            data.rel_id,
                            data.exit_id,
                            data.reject_id,
                            0,
                            data.emp_user_id,
                            data.rel_user_id,
                            data.rel_level,
                            data.reporties_count,
                            data.rpls_rm_id,
                            data.emp_name
                          )
                        "
                      >
                        Reject
                      </button>
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-primary btn-sm btn-sm-custom"
                        (click)="
                          openExitupdateModal('#exit_update_modal', data, 1)
                        "
                      >
                        <i class="fa fa-pencil-square-o"></i> Edit
                      </button>
                      <br />
                      <button
                        type="button"
                        class="btn btn-warning btn-sm btn-sm-custom m-t-5"
                        (click)="
                          openExitupdateModal('#exit_date_modal', data, 2)
                        "
                      >
                        Change Exit Date
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--  -->
            <div class="table-responsive" *ngIf="expensesCount != 0">
              <div class="text-center-font">Expense Approvals</div>
              <hr style="background: red" />
              <table class="table table-striped mb-0">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>Sr no / Status</th>
                    <th>Expense Id / Claim No.</th>
                    <th>Employee</th>
                    <th>Cost Center</th>
                    <th>Expense Amount</th>
                    <th>Vendor Name / Invoice</th>
                    <th>Expense Category</th>
                    <th>Expense Date / Entry Date</th>
                    <th>Empoyee Remark</th>
                    <th>FN Remark</th>
                    <th>Travel Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of expenseApprovals; let i = index">
                    <td>
                      {{ i + 1 }} . &nbsp; {{ item.status_desc }}
                      <br />
                      <button
                        class="btn btn-sm btn-danger text-white"
                        (click)="resolveExpense(item, '#take_action_expense')"
                      >
                        Action
                      </button>
                    </td>
                    <td>{{ item.expns_id }} / {{ item.claim_id }}</td>
                    <td>
                      {{ item.emp_name }}
                      <br />
                      <button
                        style="cursor: default"
                        class="btn-xs btn-warning"
                      >
                        {{ item.category }} - {{ item.desig_desc }}
                      </button>
                    </td>
                    <td>{{ item.expns_cc_desc }}</td>
                    <td>{{ item.expns_amt }} <br /></td>
                    <td>
                      {{ item.vendor_desc }} <br />
                      {{ item.invoice_no }} &nbsp; <br /><span
                        *ngIf="item.attachment1 == '' && item.attachment2 == ''"
                      >
                        <button
                          style="cursor: default"
                          class="btn-xs btn-warning"
                        >
                          No Bill
                        </button>
                      </span>
                      <a
                        *ngIf="item.attachment1 != ''"
                        href="{{ item.attachment1 }} "
                        class="mt-5"
                        download=" "
                        target="_blank"
                        ><button style="cursor: default" class="btn-danger">
                          <i class="fa fa-paperclip"></i> File
                        </button>
                      </a>
                      &nbsp;
                      <a
                        *ngIf="item.attachment2 != ''"
                        href="{{ item.attachment2 }} "
                        class="mt-5"
                        download=" "
                        target="_blank"
                        ><button style="cursor: default" class="btn-danger">
                          <i class="fa fa-paperclip"></i> File 2
                        </button>
                      </a>
                    </td>
                    <td>{{ item.cat_desc }}</td>
                    <td>{{ item.expns_date }} / {{ item.entry_date }}</td>
                    <td>{{ item.remarks }}</td>
                    <td>{{ item.finance_remark }}</td>
                    <td>
                      {{ item.transport_mode }} <br />
                      {{ item.travel_from }} {{ item.travel_to }} <br />
                      {{ item.travel_reason }} <br />
                      {{ item.reason_remark }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--  -->
            <div class="table-responsive" *ngIf="smarttripCount != 0">
              <div class="text-center-font">SmartTrip Approvals</div>
              <hr style="background: red" />
              <table class="table table-striped mb-0">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>Sr no / Status</th>
                    <th>Expense Id / Claim No.</th>
                    <th>Employee</th>
                    <th>Cost Center</th>
                    <th>Expense Category / Amount</th>
                    <th>Travel Details</th>
                    <th>Travel Date</th>
                    <th>Start Time / End Time</th>
                    <th>User KMS / Google KMS</th>
                    <th>Mode</th>
                    <th>FN Remark</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of smarttripApprovals; let i = index">
                    <td>
                      {{ i + 1 }} . &nbsp; {{ item.status_desc }} <br />
                      <button
                        class="btn btn-sm btn-danger text-white"
                        (click)="resolveExpense(item, '#take_action_expense')"
                      >
                        Action
                      </button>
                    </td>
                    <td>{{ item.expns_id }} / {{ item.claim_id }}</td>
                    <td>
                      {{ item.emp_name }} <br />
                      {{ item.category }} <br />{{ item.desig_desc }}
                    </td>
                    <td>{{ item.expns_cc_desc }}</td>
                    <td>
                      {{ item.cat_desc }} <br />
                      {{ item.expns_amt }}
                    </td>
                    <td>{{ item.trip_title_desc }}</td>
                    <td>{{ item.start_date }}</td>
                    <td>{{ item.start_time }} / {{ item.end_time }}</td>
                    <td>
                      {{ item.user_km_dist }} / {{ item.map_km_dist }} &nbsp;
                      <a
                        *ngIf="item.map_img != ''"
                        href="{{ item.map_img }} "
                        class="mt-5"
                        target="_blank"
                        ><button style="cursor: default" class="btn-danger">
                          <i class="fa fa-paperclip"></i> File
                        </button>
                      </a>
                    </td>
                    <td>{{ item.trip_mode_desc }}</td>
                    <td>{{ item.finance_remark }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--  -->
            <div class="table-responsive" *ngIf="awardApprovalsCount != 0">
              <div class="text-center-font">Awards Approvals</div>
              <hr style="background: red" />
              <table class="table table-striped mb-0">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>#</th>
                    <th>Award Id</th>
                    <th>Cost Center</th>
                    <th>Employee</th>
                    <th>Category</th>
                    <th>Award Name</th>
                    <th>Date</th>
                    <th>Remark</th>
                    <th>Nominated By</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of awardApprovals; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ data.awrd_id }}</td>
                    <td>{{ data.emp_cc_name }}</td>
                    <td>{{ data.emp_username }}-{{ data.emp_name }}</td>
                    <td>{{ data.cat_desc }}</td>
                    <td>{{ data.subcat_desc }}</td>
                    <!-- <td>{{data.datetime | date: 'dd/MM/yyyy H:mm:ss a'}}</td> -->
                    <td>{{ data.datetime }}</td>
                    <td>{{ data.remark }}</td>
                    <td>{{ data.nominated_by }}-{{ data.nominated_name }}</td>
                    <td>
                      <button
                        class="btn btn-sm btn-danger text-white"
                        (click)="resolveAward(data, '#take_action')"
                      >
                        Action
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--  -->
            <div class="table-responsive" *ngIf="idCardApprovalsCount != 0">
              <div class="text-center-font">ID Card Approvals</div>
              <hr style="background: red" />
              <div class="mt-10">
                <button
                  type="button"
                  (click)="submitBulkIDCardApprove('1')"
                  class="btn btn-primary btn-sm mr-10"
                >
                  Approve
                </button>
                <button
                  type="button"
                  (click)="submitBulkIDCardApprove('0')"
                  class="btn btn-danger btn-sm mr-10"
                >
                  Reject
                </button>
              </div>
              <table class="table table-striped mb-0">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>
                      <label class="form-check-label"
                        >Select all<br />
                        <input
                          type="checkbox"
                          (change)="checkUncheckAllIDCard($event)"
                        />
                      </label>
                    </th>

                    <th>Cost Center</th>
                    <th>Employee</th>
                    <th>Image</th>
                    <th>Mobile</th>
                    <th>Requested On</th>
                    <th>Status</th>
                    <th>Created By</th>
                    <th>Approve</th>
                    <th>Reject</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of idCardApprovals; let i = index">
                    <td>
                      <input type="checkbox" [(ngModel)]="data.isSelected" />
                    </td>
                    <td>{{ data.cc_ext_id }} - {{ data.cc_desc }}</td>
                    <td>
                      {{ data.emp_username }}-{{ data.emp_name }}
                      {{ data.emp_lname }}
                    </td>
                    <td *ngIf="data.req_doc_id != ''">
                      <img [src]="data.req_doc_id" height="100px" />
                    </td>
                    <td *ngIf="data.req_doc_id == ''"></td>
                    <td>{{ data.mobile }}</td>
                    <td>{{ data.req_date }}</td>
                    <td>{{ data.rel_status }}</td>
                    <td>
                      {{ data.cr_username }}-{{ data.cr_name }}
                      {{ data.cr_lname }}
                    </td>
                    <td class="text-center">
                      <button
                        class="btn btn-primary btn-sm btn-sm-custom"
                        (click)="
                          submitIDCardApprove(
                            data.rel_id,
                            data.req_id,
                            data.approve_id
                          )
                        "
                      >
                        Approve
                      </button>
                    </td>
                    <td class="text-center">
                      <button
                        class="btn btn-danger btn-sm btn-sm-custom"
                        (click)="
                          submitIDCardApprove(
                            data.rel_id,
                            data.req_id,
                            data.reject_id
                          )
                        "
                      >
                        Reject
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--  -->

            <!--Visiting Card -->
            <div class="table-responsive" *ngIf="epaApprovalsCount != 0">
              <div class="text-center-font">Aspire Year End Task Approvals</div>
              <hr style="background: red" />
              <div class="mt-10">
                <button
                  type="button"
                  (click)="submitEpaBulkApproval('1')"
                  class="btn btn-primary btn-sm mr-10"
                >
                  Approve
                </button>
                <button
                  type="button"
                  (click)="submitEpaBulkApproval('0')"
                  class="btn btn-danger btn-sm mr-10"
                >
                  Reject
                </button>
              </div>
              <table class="table table-striped mb-0">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>
                      <label class="form-check-label"
                        >Select all<br />
                        <input
                          type="checkbox"
                          (change)="checkUncheckAllVisitCard($event)"
                          [ngModelOptions]="{ standalone: true }"
                        />
                      </label>
                    </th>
                    <th>Cost Center</th>
                    <th>Employee</th>
                    <th>Manager</th>
                    <th>Overall Rating</th>
                    <th>Status</th>
                    <th>Created By</th>
                    <th>Approve</th>
                    <th>Reject</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of epaApprovals; let i = index">
                    <td>
                      <input type="checkbox" [(ngModel)]="data.isSelected" />
                    </td>
                    <td>{{ data.cc_ext_id }} - {{ data.cc_desc }}</td>
                    <td>{{ data.EmpName }}</td>
                    <td>{{ data.MngrName }}</td>
                    <td>{{ data.rating_desc }}</td>
                    <td>{{ data.rel_status }}</td>
                    <td>{{ data.CrEmpName }}</td>
                    <td class="text-center">
                      <button
                        class="btn btn-primary btn-sm btn-sm-custom"
                        (click)="submitEpaApproval(data.rel_id, '1')"
                      >
                        Aproved
                      </button>
                    </td>
                    <td class="text-center">
                      <button
                        class="btn btn-danger btn-sm btn-sm-custom"
                        (click)="submitEpaApproval(data.rel_id, '0')"
                      >
                        Reject
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--  -->

            <div class="table-responsive" *ngIf="pettyCashApprovalCount != 0">
              <div class="text-center-font">Petty Cash Request Approvals</div>
              <hr style="background: red" />
              <!-- <div class="mt-10 ">
                                <button type="button" class="btn btn-primary btn-sm mr-10 " (click)="submitPettyCashBulkApproval( '1') "> Bulk Approve</button>
                            </div> -->
              <table class="table table-striped mb-0">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>
                      <label class="form-check-label"
                        >Request ID<br />
                        <!-- <input type="checkbox" (change)="checkUncheckAllPettyCash($event) "> -->
                      </label>
                    </th>
                    <!-- <th>Request ID</th> -->
                    <th>Requested By</th>
                    <th>Cost Center</th>
                    <th>Requested Amount</th>
                    <th>Eligiblity Amount</th>
                    <th>Site Balance</th>
                    <th>Requested Date</th>
                    <th>Requestor Remark</th>
                    <th>Attachments</th>
                    <th>Approve</th>
                    <th>Reject</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of pettyCashApprovals; let i = index">
                    <td>
                      <!-- <input type="checkbox" [(ngModel)]="data.isSelected">  -->
                      <br />
                      # {{ data.rqst_id }}
                    </td>
                    <td>{{ data.requestorName }}</td>
                    <td>{{ data.siteName }}</td>
                    <td>
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      {{ data.req_amount }} <br />
                      <span class="text-danger" *ngIf="data.is_exception == 1">
                        <b> * Exception Case</b></span
                      >
                    </td>
                    <td>
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      {{ data.elg_amount }}
                    </td>
                    <td>
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      {{ data.balance }}
                    </td>
                    <td>{{ data.rqst_date | date : "dd/MM/yyyy" }}</td>
                    <td>{{ data.rqst_remark }}</td>
                    <td>
                      <a
                        [href]="data.attachment1"
                        *ngIf="data.rqst_attachment1 != ''"
                        target="_blank"
                        ><button class="btn-danger">
                          <i class="fa fa-paperclip"></i> Doc 1
                        </button></a
                      >
                      <br />&nbsp; <br />
                      <a
                        [href]="data.attachment2"
                        *ngIf="data.rqst_attachment2 != ''"
                        target="_blank"
                        ><button class="btn-danger">
                          <i class="fa fa-paperclip"></i> Doc 2
                        </button></a
                      >
                    </td>
                    <td class="text-center">
                      <button
                        class="btn btn-primary btn-sm btn-sm-custom"
                        (click)="submitPettyCashApproval(data, '1')"
                      >
                        Approve
                      </button>
                    </td>
                    <td class="text-center">
                      <button
                        class="btn btn-danger btn-sm btn-sm-custom"
                        (click)="submitPettyCashApproval(data, '0')"
                      >
                        Reject
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!--  -->

            <div
              class="table-responsive"
              *ngIf="pettyCashExpenseApprovalCount != 0"
            >
              <div class="text-center-font">Petty Cash Expense Approvals</div>
              <hr style="background: red" />
              <!-- <div class="mt-10 ">
                                <button type="button" class="btn btn-primary btn-sm mr-10 " (click)="submitPettyCashBulkApproval( '1') ">Approve</button>
                                <button type="button" class="btn btn-danger btn-sm mr-10 " (click)="submitPettyCashBulkApproval( '0') ">Reject</button>
                            </div> -->
              <table class="table table-striped mb-0">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>Txn ID</th>
                    <th>Submitted By</th>
                    <th>Cost Center</th>
                    <th>Site Balance</th>
                    <th>Amount pending in approvals</th>
                    <th>Invoice</th>
                    <th>Vendor</th>
                    <th>GL Code</th>
                    <th>Is Billable ?</th>
                    <th>Submitted Date</th>
                    <th>PO No</th>
                    <th>Approve</th>
                    <th>Reject</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let data of pettyCashExpenseApprovals;
                      let i = index
                    "
                  >
                    <td>{{ data.txn_id }}</td>
                    <td>{{ data.requestorName }}</td>
                    <td>{{ data.siteName }}</td>
                    <td>
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      {{ data.balance }}
                    </td>
                    <td>
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      {{ data.pendingAmntAppr }}
                    </td>
                    <td>
                      <b> No:</b> {{ data.vnd_invc_id }} <br />
                      <b> Date:</b> {{ data.invc_date | date : "d-LLL-y" }}
                      <br />
                      <b> Amt: </b
                      ><i
                        class="fa fa-inr"
                        aria-hidden="true"
                        *ngIf="data.invc_amt"
                      ></i
                      >{{ data.invc_amt }} <br /><a
                        [href]="data.attachment1"
                        *ngIf="data.invc_attachment1 != ''"
                        target="_blank"
                        ><button class="btn-danger">
                          <i class="fa fa-paperclip"></i> File
                        </button>
                      </a>
                      &nbsp;
                      <a
                        [href]="data.attachment2"
                        *ngIf="data.invc_spprt_attachment1 != ''"
                        target="_blank"
                        ><button class="btn-success">
                          <i class="fa fa-paperclip"></i> Sup Doc 1
                        </button></a
                      >&nbsp; &nbsp;
                      <a
                        [href]="data.attachment3"
                        *ngIf="data.invc_spprt_attachment2 != ''"
                        target="_blank"
                        ><button class="btn-success">
                          <i class="fa fa-paperclip"></i> Sup Doc 2
                        </button></a
                      >
                    </td>
                    <td>
                      {{ data.vendor_org }} <br />
                      <b> GST No: </b> {{ data.vendor_gst }}
                    </td>
                    <td>
                      <span *ngIf="data.gl_code">
                        <b> Code:</b> {{ data.gl_code }}
                      </span>
                      <span *ngIf="data.gl_desc"
                        ><br />
                        <b> Desc:</b> {{ data.gl_desc }}
                      </span>
                    </td>
                    <td>{{ data.isBillable }}</td>

                    <td>{{ data.date_of_submit }}</td>
                    <td>{{ data.po_id }}</td>
                    <td class="text-center">
                      <button
                        class="btn btn-primary btn-sm btn-sm-custom"
                        (click)="
                          submitPettyCashExpenseApproval(data.rel_id, '1')
                        "
                      >
                        Approve
                      </button>
                    </td>
                    <td class="text-center">
                      <button
                        class="btn btn-danger btn-sm btn-sm-custom"
                        (click)="
                          submitPettyCashExpenseApproval(data.rel_id, '0')
                        "
                      >
                        Reject
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!--  -->
            <div class="table-responsive" *ngIf="workPlaceApprovalsCount != 0">
              <div class="text-center-font">WorkPlace Approvals</div>
              <hr style="background: red" />
              <table class="table table-striped mb-0">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>S No.</th>
                    <th>Cost Center</th>
                    <th>Employee</th>
                    <th>Visiting Office</th>
                    <th>Visiting Dates and Time</th>
                    <th>Date of Visiting Office</th>
                    <th>End Date</th>
                    <th>HOD's Approval Email</th>
                    <th>Vaccination Certificate</th>
                    <th>Approve</th>
                    <th>Reject</th>
                  </tr>
                </thead>
                <tbody *ngFor="let data of workPlaceApprovals; let i = index">
                  <tr>
                    <td>{{ i + 1 }}</td>
                    <td>{{ data.siteName }}</td>
                    <td>{{ data.emp_name }}</td>
                    <td>{{ data.vst_office_name }}</td>
                    <td>
                      <!-- {{data.datesList}} -->
                      <button
                        type="button"
                        *ngFor="let li of data.datesList"
                        class="btn btn-primary btn-sm mt-5"
                      >
                        {{ li }}
                      </button>
                    </td>

                    <td>{{ data.start_date_of_visit }}</td>
                    <td>{{ data.end_date_of_visit }}</td>
                    <td class="text-center">
                      <a
                        [href]="data.hod_attach"
                        *ngIf="data.hod_attach != ''"
                        target="_blank"
                      >
                        <i class="fa fa-paperclip"></i>
                      </a>
                    </td>
                    <td class="text-center">
                      <a
                        [href]="data.vaccin_attach"
                        *ngIf="data.vaccin_attach != ''"
                        target="_blank"
                      >
                        <i class="fa fa-paperclip"></i>
                      </a>
                    </td>
                    <td class="text-center">
                      <button
                        class="btn btn-primary btn-sm btn-sm-custom"
                        (click)="submitWrkplaceApproval(data, '1')"
                      >
                        Approve
                      </button>
                    </td>
                    <td class="text-center">
                      <button
                        class="btn btn-danger btn-sm btn-sm-custom"
                        (click)="submitWrkplaceApproval(data, '0')"
                      >
                        Reject
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>

<!-- rejection modal -->
<div
  id="reject_remark"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
  style="z-index: 1060 !important"
>
  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
    <!-- <div class="modal-content"> -->
    <div class="modal-content" style="box-shadow: 2px 2px 5px black">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">
          Rejection Remark
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeModal()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form [formGroup]="rejectForm" (ngSubmit)="onSubmitRejection()">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Remark <span class="text-danger">*</span></label>
                <textarea
                  type="text"
                  formControlName="rej_remark"
                  class="form-control"
                  placeholder="Comments.. "
                ></textarea>
                <div
                  *ngIf="remSubmit && remarkErrorMsg.rej_remark.errors"
                  class="form-error"
                >
                  <div *ngIf="remarkErrorMsg.rej_remark.errors.required">
                    Comments is required !
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary btn-sm">Submit</button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-dismiss="modal"
            (click)="closeModal()"
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div
  id="refyn_modal"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <!-- <h5 class="modal-title" id="zero_country_form_title">Refyne Apps></h5> -->
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="row text-center">
          <div class="col-12">
            <img
              src="./assets/img/refyne_portal_icon.png"
              width="100"
              (click)="openRefyneApp('4')"
            />
            <h2>{{ cat_1 }}</h2>
          </div>
        </div>
        <div class="row text-center">
          <div class="col-4">
            <img
              src="./assets/img/User Flow Icon_CTNR.png"
              width="40"
              (click)="openRecycleLang('1')"
            />
            <h4>{{ cat_2 }}</h4>
          </div>

          <div class="col-4">
            <img
              src="./assets/img/FAQ_CTNR.png"
              width="40"
              (click)="openRecycleLang('2')"
            />
            <h4>{{ cat_3 }}</h4>
          </div>
          <div class="col-4">
            <img
              src="./assets/img/Launch_CTNR.png"
              width="40"
              (click)="openRecycleLang('3')"
            />
            <h4>Launch Deck</h4>
          </div>
        </div>
        <br /><br />
        <div class="row">
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          <h3>
            <b> {{ bottomText }} </b>
          </h3>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Select Laguage modal -->
<div
  id="lang_modal"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">
          Select Language
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="col-6">
          <div class="form-group">
            <label>Choose Your Language</label>
            <select class="form-control" [(ngModel)]="language">
              <option value="">Select</option>
              <option *ngFor="let item of refyneLang" value="{{ item.value }}">
                {{ item.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="col6">
          <div class="resetBtn">
            <button class="btn btn-warning btn-sm mr-4" (click)="viewReport()">
              View
            </button>
            <button class="btn btn-danger btn-sm" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="rs_section" [@slideInOut]="canvasState">
  <div class="sr_tab">
    <div class="sr-content">
      <div class="row">
        <div class="col-md-1 col-1">
          <button
            type="button"
            class="text-start close_btn"
            (click)="toggleMenu()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col-md-11 col-11">
          <div class="Heading_Sec">
            <h3 class="text-center">All Pending Approvals</h3>
          </div>
        </div>
      </div>
      <hr style="background: red" class="ng-tns-c217-0" />
      <div class="sr-content_in">
        <ng-template [cdkPortalOutlet]="selectedPortal"></ng-template>
      </div>
    </div>
  </div>
</div>

<!--  -->

<div
  id="myModal_s"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
  style="background: #00000063"
>
  <div
    class="modal-dialog modal-dialog-centered modal-lg"
    role="document"
    style="position: relative"
  >
    <div class="modal-content">
      <!-- <div class="log__img">
        <div class="img_baloon1 text-center">
          <img src="assets/img/baloons-2.gif" />
        </div>
        <div class="img_baloon2 text-center">
          <img src="assets/img/baloons-2.gif" />
        </div>
      </div> -->
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <!-- <div class="col-12 p-4"> -->
        <!-- <div class="text_news text-center mt-4"> -->
        <!-- <h3 class="h1 font-weight-bold mb-4">Welcome To</h3> -->
        <!-- <div class="logo__acc"> -->
        <img src="assets/img/banner.png" style="width: 100%" />
        <!-- </div> -->
        <!-- <h4 class="font-weight-bold mt-4"><u> Version 3.0 </u></h4> -->
        <!-- </div> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</div>

<!--  -->
<div id="myModal_so_news" class="modal custom-modal fade" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <!-- <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal" aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div> -->

      <div class="modal-body pt-4">
        <div class="col-12 p-4">
          <div class="img_news text-center">
            <img src="assets/img/so_news.png" />
          </div>
          <div class="text_news text-center mt-4">
            <p class="">
              All the important news and latest happening at MobiliseIndia<br />
              <span class="color_red">Just a Click Away!</span>
            </p>
          </div>
          <div class="row">
            <div class="col-2"></div>
            <div class="col-4">
              <div class="button_close text-center">
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  class="btn-sm btn-primary"
                >
                  <span aria-hidden="true">CLOSE</span>
                </button>
              </div>
            </div>
            <div class="col-4">
              <div class="button_click text-center">
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  class="btn-sm btn-danger"
                  (click)="submitToken()"
                >
                  <span aria-hidden="true">CLICK HERE</span>
                </button>
              </div>
            </div>
            <div class="col-2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  id="wish_bday"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">Send Wish</h5>
        <button
          type="button"
          class="close bg-white"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeWishModal()"
        >
          <span aria-hidden="true"
            ><img
              src="assets/new_icon/close.svg"
              class="icon-main"
              alt="sodexo"
          /></span>
        </button>
      </div>
      <div class="modal-body pb-0">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label
                >Enter message here<span class="text-danger">*</span></label
              >
              <textarea
                class="form-control"
                rows="3"
                placeholder="Write your message.."
                [(ngModel)]="bdayWish"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="submit"
          class="btn btn-warning btn-sm"
          (click)="sendWishWithMsg()"
        >
          <i class="fa fa-paper-plane"></i> Send
        </button>
      </div>
    </div>
  </div>
</div>
<app-employee-visiting-card></app-employee-visiting-card>
